var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudComputing1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192.93 164.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fdd762;}.cls-4{fill:#ff2c9c;}.cls-5{opacity:0.5;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:#173d7a;}.cls-8{clip-path:url(#clip-path-4);}.cls-9{fill:#721bd5;}.cls-10{fill:#b45ef4;}.cls-11{fill:#8a2ae3;}.cls-12{fill:#95d359;}.cls-13{fill:#c13d1a;}.cls-14{fill:#db5126;}.cls-15{fill:#ef602e;}.cls-16{fill:#d3008d;}.cls-17{fill:#e8a200;}.cls-18{fill:#f9bf30;}.cls-19{fill:#5793ce;}.cls-20{fill:#396caa;}.cls-21{fill:#d4ecff;}.cls-22{fill:#fff;}.cls-23{clip-path:url(#clip-path-5);}.cls-24{fill:#fafdff;}.cls-25{opacity:0.4;}.cls-26{clip-path:url(#clip-path-6);}.cls-27{clip-path:url(#clip-path-7);}.cls-28{clip-path:url(#clip-path-8);}.cls-29{clip-path:url(#clip-path-9);}.cls-30{clip-path:url(#clip-path-10);}.cls-31{clip-path:url(#clip-path-11);}.cls-32{clip-path:url(#clip-path-12);}.cls-33{clip-path:url(#clip-path-13);}.cls-34{clip-path:url(#clip-path-14);}.cls-35{clip-path:url(#clip-path-15);}.cls-36{clip-path:url(#clip-path-16);}.cls-37{clip-path:url(#clip-path-17);}.cls-38{clip-path:url(#clip-path-18);}.cls-39{clip-path:url(#clip-path-19);}.cls-40{clip-path:url(#clip-path-20);}.cls-41{clip-path:url(#clip-path-21);}.cls-42{fill:#274f89;}.cls-43{clip-path:url(#clip-path-22);}.cls-44{fill:#983be9;}.cls-45{fill:#ffc2b0;}.cls-46{fill:#ea9c92;}.cls-47{fill:#6614cf;}.cls-48{clip-path:url(#clip-path-23);}.cls-49{clip-path:url(#clip-path-24);}.cls-50{clip-path:url(#clip-path-25);}.cls-51{fill:#d8892b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 192.93,
    height: 164.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 158.48,
    y: 104.41,
    width: 11.5,
    height: 6.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.73,
    y: 101.09,
    width: 11.5,
    height: 6.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.3,
    y: 90.52,
    width: 35.8,
    height: 20.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.85,
    y: 50.68,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.85,
    y: 57.03,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.85,
    y: 63.37,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.85,
    y: 69.71,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.85,
    y: 76.06,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.85,
    y: 82.4,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.85,
    y: 88.74,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.06,
    y: 105.86,
    width: 35.8,
    height: 20.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.61,
    y: 66.02,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.61,
    y: 72.37,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.61,
    y: 78.71,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.61,
    y: 85.05,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.61,
    y: 91.4,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.61,
    y: 97.74,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.61,
    y: 104.08,
    width: 18.56,
    height: 14.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.51,
    y: 110.22,
    width: 86.03,
    height: 49.66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.09,
    y: 93.32,
    width: 11.5,
    height: 6.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.66,
    y: 103.54,
    width: 19.02,
    height: 10.98
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.96,
    y: 135.46,
    width: 19.61,
    height: 11.32
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.68,
    y: 153.87,
    width: 17.81,
    height: 10.28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    className: "cls-3",
    x: 0.03,
    y: 97.11,
    width: 3.08,
    height: 1.06,
    transform: "translate(-55.8 18.61) rotate(-35.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    className: "cls-3",
    x: 0.92,
    y: 95.19,
    width: 3.08,
    height: 1.06,
    transform: "translate(-54.52 18.77) rotate(-35.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    className: "cls-3",
    x: 1.82,
    y: 93.27,
    width: 3.08,
    height: 1.06,
    transform: "translate(-53.25 18.94) rotate(-35.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    className: "cls-3",
    x: 2.72,
    y: 91.34,
    width: 3.08,
    height: 1.06,
    transform: "translate(-51.98 19.1) rotate(-35.04)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    className: "cls-4",
    d: "M167.69,58.41l.48-.81a1.13,1.13,0,0,0,.83.08,1.63,1.63,0,0,0,.88-.92A2.81,2.81,0,0,1,173,55l-.22.91.11-.45-.11.45a1.87,1.87,0,0,0-2.07,1.22,2.45,2.45,0,0,1-1.46,1.41,2.09,2.09,0,0,1-1.57-.17",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    className: "cls-7",
    d: "M170,107.73l-5.75-3.32-5.76,3.32,5.76,3.33Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    className: "cls-7",
    d: "M164.24,104.41l-5.76-3.32-5.75,3.32,5.75,3.32Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    className: "cls-9",
    d: "M165.1,101.59V91.65L170,88.83v9.94Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    className: "cls-10",
    d: "M165.1,91.65l-4.88-2.82v9.94l4.88,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    className: "cls-11",
    d: "M170,88.83,165.1,86l-4.88,2.82,4.88,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    className: "cls-12",
    d: "M170,102.53l-4.89-2.82v1.88l4.89,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    className: "cls-13",
    d: "M160.22,104.41v-15l4.88-2.82v15Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    className: "cls-14",
    d: "M160.22,89.37l-4.89-2.82v15l4.89,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    className: "cls-15",
    d: "M165.1,86.55l-4.88-2.82-4.89,2.82,4.89,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    className: "cls-16",
    d: "M160.22,104.41v-15l4.88-2.82v15Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    className: "cls-16",
    d: "M160.22,89.37l-4.89-2.82v15l4.89,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    className: "cls-4",
    d: "M165.1,86.55l-4.88-2.82-4.89,2.82,4.89,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    className: "cls-17",
    d: "M165.1,107.23V98.77L170,96v8.46Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    className: "cls-18",
    d: "M165.1,98.77,160.22,96v8.46l4.88,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    className: "cls-3",
    d: "M170,96l-4.89-2.82L160.22,96l4.88,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    className: "cls-19",
    d: "M119.87,52.87a.4.4,0,0,1-.39-.4V36.21a.4.4,0,1,1,.79,0V52.47a.4.4,0,0,1-.4.4",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    className: "cls-19",
    x: 118.46,
    y: 35.19,
    width: 2.83,
    height: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    className: "cls-19",
    d: "M120.87,41.86a2.2,2.2,0,0,1-2,0,.62.62,0,0,1-.38-.77.6.6,0,0,1,.38-.38,2.2,2.2,0,0,1,2,0,.61.61,0,0,1,0,1.15",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    className: "cls-19",
    x: 117.58,
    y: 26.69,
    width: 4.58,
    height: 9.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    className: "cls-20",
    d: "M118.46,36.19v2.06a3.66,3.66,0,0,0,2.83,0V36.19a3.66,3.66,0,0,0-2.83,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    className: "cls-19",
    d: "M121.49,37.18a3.54,3.54,0,0,1-3.23,0,1,1,0,0,1,0-1.86,3.54,3.54,0,0,1,3.23,0,1,1,0,0,1,0,1.86",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    className: "cls-19",
    d: "M135.73,61.79a.39.39,0,0,1-.39-.4V45.13a.38.38,0,0,1,.39-.39.39.39,0,0,1,.4.39V61.39a.4.4,0,0,1-.4.4",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    className: "cls-19",
    x: 134.32,
    y: 44.11,
    width: 2.83,
    height: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    className: "cls-19",
    d: "M136.73,50.78a2.2,2.2,0,0,1-2,0,.61.61,0,0,1,0-1.15,2.2,2.2,0,0,1,2,0,.61.61,0,0,1,0,1.15",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    className: "cls-19",
    x: 133.44,
    y: 35.61,
    width: 4.58,
    height: 9.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    className: "cls-20",
    d: "M134.32,45.11v2.06a3.66,3.66,0,0,0,2.83,0V45.11a3.66,3.66,0,0,0-2.83,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    className: "cls-19",
    d: "M137.35,46.11a3.62,3.62,0,0,1-3.24,0,1,1,0,0,1,0-1.87,3.56,3.56,0,0,1,3.24,0,1,1,0,0,1,0,1.87",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    className: "cls-19",
    d: "M151.15,51.48l6.13-3.62-5.84-7.29-1.54,2.51Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    className: "cls-19",
    d: "M106.58,11.43l9.79-5.63L116,11.43l-5.63,1.75Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    className: "cls-19",
    d: "M152.85,33.13a6.18,6.18,0,0,0-2.12-.79c-1-5.19-4.59-10.7-8.9-13.19a8.79,8.79,0,0,0-3.65-1.23c-.58-6.29-5-13.44-10.27-16.51-2.78-1.6-5.29-1.79-7.15-.81h0l-.09.05-.14.08-5.78,3.41,1.92,1.52c-1.72.75-2.81,2.68-2.81,5.54,0,5.27,3.69,11.67,8.26,14.31l30.73,21.94c3.43,2,6.21.38,6.21-3.57a13.71,13.71,0,0,0-6.21-10.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    className: "cls-19",
    d: "M114.14,8.88,127.4,1.13c-2.57-1.34-4.9-1.45-6.64-.53h0l-.09.05-.14.08-5.78,3.41,1.92,1.52a4.61,4.61,0,0,0-2.53,3.22",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    className: "cls-19",
    d: "M138.63,31.67,148.3,26a18.74,18.74,0,0,0-6.47-6.84q-.51-.28-1-.51l-12.31,7.2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    className: "cls-21",
    d: "M117.47,4.77l4.32,2.49,7.89-4.65a15.28,15.28,0,0,0-1.77-1.2A11.15,11.15,0,0,0,125.15.25Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    className: "cls-21",
    d: "M147.23,24.32l-7.72,4.55,2.69,3,7-4.14a22.76,22.76,0,0,0-2-3.41",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    className: "cls-21",
    d: "M146.79,36.7a6.16,6.16,0,0,0-2.12-.78c-1-5.19-4.6-10.71-8.91-13.19a8.77,8.77,0,0,0-3.64-1.24c-.59-6.29-5-13.44-10.28-16.51-5.71-3.3-10.34-.62-10.34,6,0,.22,0,.44,0,.67-4.18-1.94-7.45.25-7.45,5.2,0,5.26,3.7,11.67,8.27,14.3L146.79,51c3.43,2,6.2.37,6.2-3.58a13.7,13.7,0,0,0-6.2-10.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    className: "cls-22",
    d: "M111.51,11.63c0-.23,0-.45,0-.67v0c-2.31-.9-4.29-.51-5.54.93,1.35-1.11,3.32-1.27,5.55-.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    className: "cls-22",
    d: "M147.29,36.21a6.18,6.18,0,0,0-2.12-.79c-1-5.18-4.6-10.7-8.9-13.18A8.77,8.77,0,0,0,132.63,21c-.59-6.29-5-13.44-10.28-16.51-3.56-2.05-6.7-1.79-8.56.3,1.9-1.62,4.8-1.69,8.06.19,5.31,3.07,9.68,10.22,10.27,16.51a8.81,8.81,0,0,1,3.65,1.24c4.3,2.48,7.91,8,8.9,13.19a6.16,6.16,0,0,1,2.12.78A13.7,13.7,0,0,1,153,47.45a5.07,5.07,0,0,1-1,3.3A4.6,4.6,0,0,0,153.5,47a13.73,13.73,0,0,0-6.2-10.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    className: "cls-20",
    d: "M110.79,13.2l2.59,1.2-.14-2.85c0-.2,0-.4,0-.59,0-2.55.77-4.4,2.16-5.2s3.38-.55,5.59.72c4.74,2.74,8.88,9.4,9.41,15.17l.14,1.46,1.45.11a7.07,7.07,0,0,1,2.92,1c3.76,2.17,7.16,7.22,8.07,12l.23,1.2,1.2.19a4.3,4.3,0,0,1,1.52.57,12,12,0,0,1,5.34,9.25,2.82,2.82,0,0,1-.95,2.51,2.82,2.82,0,0,1-2.65-.43L113.2,29.63c-4-2.31-7.4-8.18-7.4-12.8,0-1.82.54-3.2,1.47-3.8a2.58,2.58,0,0,1,1.38-.37,5.33,5.33,0,0,1,2.14.54",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    className: "cls-19",
    d: "M128,34.8l.91-.46-.89-.68Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    className: "cls-19",
    d: "M125.25,22.52l.89-.45v.47Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    className: "cls-19",
    d: "M130.58,31.93l.92-.47-1.78-1.68Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    className: "cls-19",
    d: "M128.63,34.31l-4.31-2.53a.93.93,0,0,1-.39-.73v-5l5.1,3,0,5c0,.28-.18.39-.4.26",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    className: "cls-19",
    d: "M126.13,22.08l-4.65,3c-.2.13,0,.6.26.78l4.75,2.79,4.74,2.8c.3.17.46-.11.27-.47l-4.62-8.44c-.2-.37-.56-.58-.76-.45",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    className: "cls-21",
    d: "M127.7,34.78l-4.3-2.54a.9.9,0,0,1-.39-.72v-5l5.09,3v5c0,.27-.18.39-.4.26",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    className: "cls-21",
    d: "M125.2,22.54l-4.65,3c-.19.13,0,.6.27.78l4.74,2.8,4.75,2.79c.3.18.46-.11.26-.46L126,23c-.2-.36-.56-.58-.76-.45",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    className: "cls-21",
    d: "M119.44,40.23a.27.27,0,0,1-.44.25,1,1,0,0,1-.44-.76c0-.28.2-.4.44-.26a1,1,0,0,1,.44.77",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    className: "cls-21",
    d: "M135.34,49.28c0,.28-.2.39-.44.25a1,1,0,0,1-.44-.76c0-.28.19-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    className: "cls-7",
    d: "M106.93,110.76,86.8,99.28c-.74-.43-.65-1.17.2-1.66l11.59-6.69a3.19,3.19,0,0,1,2.87-.12l20.14,11.48c.74.43.64,1.17-.21,1.66l-11.58,6.69a3.21,3.21,0,0,1-2.88.12",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    className: "cls-20",
    d: "M123.39,98.43h0v-47l-18.68-4.89-3.45-2a3.41,3.41,0,0,0-3.08.13L95,46.52H85L88,91.9a.9.9,0,0,0,.53.82l18.65,14.08a3.47,3.47,0,0,0,3.09-.13l12.42-7.18a1.2,1.2,0,0,0,.75-1.06",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    className: "cls-21",
    d: "M99.83,44.23a3.57,3.57,0,0,0-1.65.44L95,46.52H85V93.65a.92.92,0,0,0,.53.83l21.6,12.32a2.84,2.84,0,0,0,1.43.3l.23-47.43Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    className: "cls-19",
    d: "M107.33,106.89a3.47,3.47,0,0,0,2.46,0V59.11h-2.46Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    className: "cls-21",
    d: "M107.13,59.68,85.53,47.36c-.79-.46-.69-1.26.22-1.78L98.18,38.4a3.44,3.44,0,0,1,3.08-.13l21.6,12.32c.8.46.7,1.26-.22,1.78l-12.43,7.18a3.41,3.41,0,0,1-3.08.13",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    className: "cls-24",
    d: "M122.64,51.5l-12.43,7.17a3.41,3.41,0,0,1-3.08.13L85.53,46.48a1.09,1.09,0,0,1-.39-.35.83.83,0,0,0,.24,1.15l.15.08,21.6,12.32a3.47,3.47,0,0,0,3.09-.13l12.43-7.18c.7-.41.92-1,.61-1.43a1.72,1.72,0,0,1-.61.56",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    className: "cls-7",
    d: "M107.74,54.68,93.36,46.35c-.37-.22-.32-.59.11-.84l5.81-3.35a1.59,1.59,0,0,1,1.44-.06l14.39,8.33c.37.22.32.59-.11.84l-5.81,3.35a1.61,1.61,0,0,1-1.45.06",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    className: "cls-21",
    d: "M100,46.72l-.83-.48c-.06,0-.05-.08,0-.11l.8-.47a.24.24,0,0,1,.2,0l.84.48s0,.08,0,.12l-.8.46a.2.2,0,0,1-.2,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    className: "cls-21",
    d: "M102.76,48.32l-.83-.48c-.05,0-.05-.08,0-.11l.81-.47a.23.23,0,0,1,.2,0l.83.48a.06.06,0,0,1,0,.12l-.81.46a.2.2,0,0,1-.2,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    className: "cls-21",
    d: "M105.55,49.92l-.84-.48s0-.08,0-.11l.8-.47a.23.23,0,0,1,.2,0l.84.48c.05,0,0,.09,0,.12l-.8.46a.2.2,0,0,1-.2,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    className: "cls-21",
    d: "M108.33,51.52,107.5,51s0-.08,0-.11l.81-.47a.27.27,0,0,1,.2,0l.83.49c.05,0,.05.08,0,.11l-.81.47a.23.23,0,0,1-.2,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    className: "cls-19",
    d: "M93.36,46.35h0l.09-.06,5.81-3.36a1.59,1.59,0,0,1,1.44-.06l14.37,8.33c.34-.25.36-.58,0-.78L100.72,42.1a1.59,1.59,0,0,0-1.44.06l-5.81,3.35c-.43.25-.48.62-.11.84",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    className: "cls-7",
    d: "M112.64,69l8.18-4.68a2,2,0,0,0,.83-1.59V59.79c0-.61-.37-.89-.83-.63l-8.18,4.68a2,2,0,0,0-.83,1.6v2.92c0,.61.37.9.83.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    className: "cls-22",
    d: "M121.22,59.07a.82.82,0,0,1,.21.61v2.93a2,2,0,0,1-.83,1.59l-8.18,4.68a.57.57,0,0,1-.4.09.5.5,0,0,0,.62,0l8.18-4.68a2,2,0,0,0,.83-1.59V59.79c0-.42-.17-.67-.43-.72",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    className: "cls-20",
    d: "M115.1,65.81l.75-.43A.44.44,0,0,0,116,65v-.8c0-.13-.08-.19-.18-.14l-.75.43a.45.45,0,0,0-.18.35v.81c0,.13.08.19.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    className: "cls-22",
    d: "M117.61,64.37l.75-.44a.42.42,0,0,0,.18-.34v-.8c0-.14-.08-.2-.18-.14l-.75.43a.44.44,0,0,0-.18.35v.8c0,.13.08.19.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    className: "cls-7",
    d: "M112.64,90.12l8.18-4.68a2,2,0,0,0,.83-1.59V80.92c0-.61-.37-.89-.83-.63L112.64,85a2,2,0,0,0-.83,1.6v2.92c0,.61.37.9.83.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    className: "cls-22",
    d: "M121.22,80.2a.82.82,0,0,1,.21.61v2.93a2,2,0,0,1-.83,1.59L112.42,90a.57.57,0,0,1-.4.09.5.5,0,0,0,.62,0l8.18-4.68a2,2,0,0,0,.83-1.59V80.92c0-.41-.17-.67-.43-.72",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    className: "cls-20",
    d: "M115.1,86.94l.75-.43a.44.44,0,0,0,.18-.35v-.8c0-.13-.08-.19-.18-.14l-.75.44a.43.43,0,0,0-.18.34v.81c0,.13.08.19.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    className: "cls-22",
    d: "M117.61,85.5l.75-.44a.42.42,0,0,0,.18-.34v-.8c0-.14-.08-.2-.18-.14l-.75.43a.44.44,0,0,0-.18.35v.8c0,.13.08.19.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    className: "cls-7",
    d: "M112.64,100.69,120.82,96a2,2,0,0,0,.83-1.59V91.49c0-.62-.37-.9-.83-.63l-8.18,4.68a2,2,0,0,0-.83,1.59v2.93c0,.61.37.89.83.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    className: "cls-22",
    d: "M121.22,90.77a.82.82,0,0,1,.21.61V94.3a2,2,0,0,1-.83,1.59l-8.18,4.69a.62.62,0,0,1-.4.08.48.48,0,0,0,.62,0L120.82,96a2,2,0,0,0,.83-1.59V91.49c0-.42-.17-.68-.43-.72",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    className: "cls-20",
    d: "M115.1,97.51l.75-.43a.44.44,0,0,0,.18-.35v-.8c0-.14-.08-.2-.18-.14l-.75.43a.44.44,0,0,0-.18.35v.8c0,.14.08.2.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    className: "cls-22",
    d: "M117.61,96.06l.75-.43a.44.44,0,0,0,.18-.35v-.8c0-.13-.08-.19-.18-.14l-.75.44a.42.42,0,0,0-.18.34v.8c0,.14.08.2.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    className: "cls-7",
    d: "M112.64,79.56l8.18-4.69a2,2,0,0,0,.83-1.59V70.36c0-.62-.37-.9-.83-.63l-8.18,4.68a2,2,0,0,0-.83,1.59v2.93c0,.61.37.89.83.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    className: "cls-22",
    d: "M121.22,69.64a.79.79,0,0,1,.21.61v2.92a2,2,0,0,1-.83,1.59l-8.18,4.69a.62.62,0,0,1-.4.08.47.47,0,0,0,.62,0l8.18-4.68a2,2,0,0,0,.83-1.59V70.36c0-.42-.17-.68-.43-.72",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    className: "cls-20",
    d: "M115.1,76.38l.75-.43a.44.44,0,0,0,.18-.35v-.8c0-.14-.08-.2-.18-.14l-.75.43a.44.44,0,0,0-.18.35v.8c0,.14.08.2.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    className: "cls-22",
    d: "M117.61,74.93l.75-.43a.44.44,0,0,0,.18-.35v-.8c0-.13-.08-.19-.18-.14l-.75.44a.43.43,0,0,0-.18.34v.8c0,.14.08.2.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    className: "cls-19",
    d: "M105.56,66,86.69,55.11a1.84,1.84,0,0,1-.76-1.47V50.05c0-.57.34-.82.76-.58l18.87,10.89a1.84,1.84,0,0,1,.76,1.46v3.6c0,.56-.34.82-.76.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    className: "cls-21",
    d: "M105,64.73,87.23,54.47a.94.94,0,0,1-.38-.74V51c0-.28.17-.42.38-.29L105,61a.9.9,0,0,1,.38.74v2.7c0,.29-.17.42-.38.29",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    className: "cls-21",
    d: "M90.94,55.24l-2.65-1.53a.91.91,0,0,1-.38-.72c0-.28.17-.41.38-.29l2.65,1.54a.91.91,0,0,1,.38.72c0,.28-.17.4-.38.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    className: "cls-7",
    d: "M93.2,56c0,.28-.19.39-.43.26a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    className: "cls-7",
    d: "M94.74,56.93c0,.28-.2.39-.44.25a.94.94,0,0,1-.43-.75c0-.28.19-.39.43-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    className: "cls-21",
    d: "M96.27,57.82c0,.28-.19.39-.43.25a1,1,0,0,1-.44-.76.27.27,0,0,1,.44-.25,1,1,0,0,1,.43.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    className: "cls-7",
    d: "M97.81,58.7c0,.28-.2.39-.44.25a.91.91,0,0,1-.43-.75c0-.28.19-.39.43-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    className: "cls-7",
    d: "M104.27,63.23l-.89-.52a.6.6,0,0,1-.25-.46v-.94c0-.18.11-.26.25-.19l.89.52a.57.57,0,0,1,.24.46v.95c0,.17-.11.26-.24.18",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    className: "cls-19",
    d: "M105.56,72.34,86.69,61.45A1.84,1.84,0,0,1,85.93,60v-3.6c0-.56.34-.82.76-.58L105.56,66.7a1.84,1.84,0,0,1,.76,1.46v3.6c0,.56-.34.82-.76.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    className: "cls-21",
    d: "M105,71.08,87.23,60.81a.92.92,0,0,1-.38-.74v-2.7c0-.29.17-.42.38-.3L105,67.34a.91.91,0,0,1,.38.74v2.71c0,.28-.17.41-.38.29",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    className: "cls-21",
    d: "M90.94,61.58l-2.65-1.53a.9.9,0,0,1-.38-.72c0-.28.17-.4.38-.28l2.65,1.53a.93.93,0,0,1,.38.72c0,.28-.17.4-.38.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    className: "cls-22",
    d: "M93.2,62.39c0,.28-.19.39-.43.25a1,1,0,0,1-.44-.75c0-.28.2-.39.44-.26a1,1,0,0,1,.43.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    className: "cls-7",
    d: "M94.74,63.27c0,.28-.2.39-.44.25a.91.91,0,0,1-.43-.75c0-.28.19-.39.43-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    className: "cls-21",
    d: "M96.27,64.16c0,.28-.19.39-.43.25a1,1,0,0,1-.44-.75c0-.28.2-.39.44-.25a.93.93,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    className: "cls-7",
    d: "M97.81,65.05a.27.27,0,0,1-.44.25.94.94,0,0,1-.43-.76c0-.28.19-.39.43-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    className: "cls-7",
    d: "M104.27,69.57l-.89-.51a.62.62,0,0,1-.25-.47v-.94c0-.18.11-.26.25-.18l.89.51a.57.57,0,0,1,.24.46v1c0,.18-.11.26-.24.18",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    className: "cls-19",
    d: "M105.56,78.68,86.69,67.79a1.84,1.84,0,0,1-.76-1.46v-3.6c0-.56.34-.82.76-.57l18.87,10.89a1.84,1.84,0,0,1,.76,1.46v3.6c0,.56-.34.82-.76.57",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    className: "cls-21",
    d: "M105,77.42,87.23,67.16a1,1,0,0,1-.38-.75v-2.7c0-.29.17-.42.38-.29L105,73.68a.92.92,0,0,1,.38.74v2.71c0,.28-.17.42-.38.29",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    className: "cls-21",
    d: "M90.94,67.93l-2.65-1.54a.89.89,0,0,1-.38-.72c0-.27.17-.4.38-.28l2.65,1.53a.94.94,0,0,1,.38.72c0,.28-.17.41-.38.29",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    className: "cls-22",
    d: "M93.2,68.73c0,.28-.19.39-.43.25a.94.94,0,0,1-.44-.75c0-.28.2-.39.44-.25a1,1,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    className: "cls-7",
    d: "M94.74,69.62c0,.28-.2.39-.44.25a.94.94,0,0,1-.43-.75c0-.28.19-.4.43-.26a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    className: "cls-21",
    d: "M96.27,70.5c0,.28-.19.39-.43.25A.94.94,0,0,1,95.4,70c0-.28.2-.39.44-.25a1,1,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    className: "cls-7",
    d: "M97.81,71.39c0,.28-.2.39-.44.25a.94.94,0,0,1-.43-.75c0-.28.19-.39.43-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    className: "cls-7",
    d: "M104.27,75.92l-.89-.52a.61.61,0,0,1-.25-.46V74c0-.18.11-.26.25-.18l.89.51a.58.58,0,0,1,.24.47v.94c0,.18-.11.26-.24.19",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    className: "cls-19",
    d: "M105.56,85,86.69,74.13a1.82,1.82,0,0,1-.76-1.46V69.08c0-.57.34-.83.76-.58l18.87,10.89a1.84,1.84,0,0,1,.76,1.46v3.6c0,.56-.34.82-.76.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    className: "cls-21",
    d: "M105,83.77,87.23,73.5a.94.94,0,0,1-.38-.74V70.05c0-.28.17-.42.38-.29L105,80a.9.9,0,0,1,.38.74v2.7c0,.29-.17.42-.38.3",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    className: "cls-21",
    d: "M90.94,74.27l-2.65-1.53a.91.91,0,0,1-.38-.72c0-.28.17-.41.38-.29l2.65,1.54a.91.91,0,0,1,.38.72c0,.28-.17.4-.38.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    className: "cls-7",
    d: "M93.2,75.07c0,.28-.19.39-.43.26a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    className: "cls-7",
    d: "M94.74,76c0,.28-.2.39-.44.25a.94.94,0,0,1-.43-.75c0-.28.19-.39.43-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    className: "cls-21",
    d: "M96.27,76.85c0,.28-.19.39-.43.25a1,1,0,0,1-.44-.76.27.27,0,0,1,.44-.25,1,1,0,0,1,.43.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    className: "cls-7",
    d: "M97.81,77.73c0,.28-.2.39-.44.25a.91.91,0,0,1-.43-.75c0-.28.19-.39.43-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    className: "cls-21",
    d: "M104.27,82.26l-.89-.52a.6.6,0,0,1-.25-.46v-.94c0-.18.11-.26.25-.19l.89.52a.57.57,0,0,1,.24.46v1c0,.17-.11.26-.24.18",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    className: "cls-19",
    d: "M105.56,91.37,86.69,80.48A1.84,1.84,0,0,1,85.93,79v-3.6c0-.56.34-.82.76-.58l18.87,10.9a1.8,1.8,0,0,1,.76,1.46v3.59c0,.57-.34.83-.76.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    className: "cls-21",
    d: "M105,90.11,87.23,79.84a.92.92,0,0,1-.38-.74V76.4c0-.29.17-.42.38-.3L105,86.37a.91.91,0,0,1,.38.74v2.71c0,.28-.17.41-.38.29",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    className: "cls-21",
    d: "M90.94,80.61l-2.65-1.53a.9.9,0,0,1-.38-.72c0-.28.17-.4.38-.28l2.65,1.53a.93.93,0,0,1,.38.72c0,.28-.17.4-.38.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    className: "cls-7",
    d: "M93.2,81.42c0,.28-.19.39-.43.25a1,1,0,0,1-.44-.75c0-.28.2-.39.44-.25a.93.93,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    className: "cls-22",
    d: "M94.74,82.3c0,.28-.2.39-.44.26a.94.94,0,0,1-.43-.76c0-.28.19-.39.43-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    className: "cls-21",
    d: "M96.27,83.19c0,.28-.19.39-.43.25a1,1,0,0,1-.44-.75c0-.28.2-.39.44-.25a.93.93,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    className: "cls-22",
    d: "M97.81,84.08c0,.28-.2.39-.44.25a.94.94,0,0,1-.43-.76c0-.27.19-.39.43-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    className: "cls-21",
    d: "M104.27,88.6l-.89-.51a.61.61,0,0,1-.25-.46v-.95c0-.18.11-.26.25-.18l.89.51a.57.57,0,0,1,.24.46v1c0,.18-.11.26-.24.18",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    className: "cls-19",
    d: "M105.56,97.71,86.69,86.82a1.84,1.84,0,0,1-.76-1.46v-3.6c0-.56.34-.82.76-.57l18.87,10.89a1.84,1.84,0,0,1,.76,1.46v3.6c0,.56-.34.82-.76.57",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    className: "cls-21",
    d: "M105,96.45,87.23,86.19a1,1,0,0,1-.38-.75v-2.7c0-.29.17-.42.38-.29L105,92.71a.93.93,0,0,1,.38.75v2.7c0,.29-.17.42-.38.29",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    className: "cls-21",
    d: "M90.94,87l-2.65-1.54a.89.89,0,0,1-.38-.72c0-.27.17-.4.38-.28L90.94,86a.94.94,0,0,1,.38.72c0,.28-.17.41-.38.29",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    className: "cls-7",
    d: "M93.2,87.76c0,.28-.19.39-.43.25a.94.94,0,0,1-.44-.75c0-.28.2-.39.44-.25a1,1,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    className: "cls-7",
    d: "M94.74,88.65c0,.28-.2.39-.44.25a.94.94,0,0,1-.43-.75c0-.28.19-.39.43-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    className: "cls-21",
    d: "M96.27,89.53c0,.28-.19.39-.43.25A.94.94,0,0,1,95.4,89c0-.28.2-.39.44-.25a1,1,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    className: "cls-7",
    d: "M97.81,90.42c0,.28-.2.39-.44.25a.94.94,0,0,1-.43-.75c0-.28.19-.39.43-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    className: "cls-7",
    d: "M104.27,94.94l-.89-.51a.61.61,0,0,1-.25-.46V93c0-.18.11-.26.25-.18l.89.51a.58.58,0,0,1,.24.47v.94c0,.18-.11.26-.24.19",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    className: "cls-19",
    d: "M105.56,104.06,86.69,93.17a1.86,1.86,0,0,1-.76-1.47V88.11c0-.57.34-.82.76-.58l18.87,10.89a1.84,1.84,0,0,1,.76,1.46v3.6c0,.56-.34.82-.76.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    className: "cls-21",
    d: "M105,102.8,87.23,92.53a.94.94,0,0,1-.38-.74V89.08c0-.28.17-.42.38-.29L105,99.06a.9.9,0,0,1,.38.74v2.7c0,.29-.17.42-.38.3",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    className: "cls-21",
    d: "M90.94,93.3l-2.65-1.53a.91.91,0,0,1-.38-.72c0-.28.17-.41.38-.29l2.65,1.54a.91.91,0,0,1,.38.72c0,.28-.17.4-.38.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    className: "cls-22",
    d: "M103.13,100c0,.52-.36.74-.82.47a1.81,1.81,0,0,1-.82-1.42c0-.52.37-.74.82-.47a1.78,1.78,0,0,1,.82,1.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    className: "cls-7",
    d: "M93.2,94.18c0,.28-.19.39-.43.26a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    className: "cls-21",
    d: "M94.74,95.07c0,.28-.2.39-.44.25a.94.94,0,0,1-.43-.75c0-.28.19-.39.43-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    className: "cls-7",
    d: "M96.27,96c0,.28-.19.39-.43.25a1,1,0,0,1-.44-.76.27.27,0,0,1,.44-.25,1,1,0,0,1,.43.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    className: "cls-7",
    d: "M133.7,126.1l-20.14-11.48c-.74-.43-.64-1.17.21-1.66l11.58-6.69a3.21,3.21,0,0,1,2.88-.12l20.13,11.48c.74.43.65,1.17-.2,1.66L136.57,126a3.19,3.19,0,0,1-2.87.12",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    className: "cls-20",
    d: "M150.16,113.77h0v-47l-18.69-4.89-3.44-2A3.41,3.41,0,0,0,125,60l-3.22,1.85h-10l3,45.38a.87.87,0,0,0,.53.82l18.65,14.07A3.41,3.41,0,0,0,137,122l12.43-7.18a1.23,1.23,0,0,0,.75-1.06",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    className: "cls-21",
    d: "M126.6,59.57a3.58,3.58,0,0,0-1.66.44l-3.21,1.85h-10V109a.92.92,0,0,0,.53.83l21.61,12.32a2.82,2.82,0,0,0,1.43.3L135.55,75Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    className: "cls-19",
    d: "M134.09,122.23a3.5,3.5,0,0,0,2.47,0V74.45h-2.47Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    className: "cls-21",
    d: "M133.9,75,112.29,62.7c-.79-.46-.69-1.26.22-1.78l12.43-7.18a3.41,3.41,0,0,1,3.08-.12l21.61,12.31c.79.46.69,1.26-.23,1.78L137,74.89a3.43,3.43,0,0,1-3.09.13",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    className: "cls-24",
    d: "M149.41,66.84,137,74a3.41,3.41,0,0,1-3.08.13L112.29,61.82a1.09,1.09,0,0,1-.39-.35.84.84,0,0,0,.24,1.15l.15.08L133.9,75a3.41,3.41,0,0,0,3.08-.12l12.43-7.18c.71-.41.92-1,.61-1.43a1.81,1.81,0,0,1-.61.56",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    className: "cls-7",
    d: "M134.5,70l-14.38-8.33c-.37-.22-.32-.59.11-.84L126,57.49a1.66,1.66,0,0,1,1.44-.06l14.38,8.34c.38.22.33.59-.1.83L136,70a1.61,1.61,0,0,1-1.45.06",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    className: "cls-21",
    d: "M126.74,62.06l-.83-.48s0-.08,0-.12l.81-.46a.2.2,0,0,1,.2,0l.83.48s0,.08,0,.12l-.81.46a.2.2,0,0,1-.2,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    className: "cls-21",
    d: "M129.53,63.66l-.84-.48c-.05,0,0-.08,0-.12l.8-.46a.23.23,0,0,1,.2,0l.84.48s0,.08,0,.12l-.8.46a.2.2,0,0,1-.2,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    className: "cls-21",
    d: "M132.31,65.26l-.83-.48s0-.08,0-.11l.81-.47a.23.23,0,0,1,.2,0l.83.48s0,.08,0,.12l-.8.46a.2.2,0,0,1-.2,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    className: "cls-21",
    d: "M135.09,66.87l-.83-.49s0-.08,0-.11l.81-.47a.23.23,0,0,1,.2,0l.83.48s0,.08,0,.11l-.81.47a.27.27,0,0,1-.2,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    className: "cls-19",
    d: "M120.12,61.69h0a.24.24,0,0,1,.09-.06L126,58.28a1.59,1.59,0,0,1,1.44-.06l14.37,8.32c.34-.24.36-.57,0-.77l-14.39-8.33a1.62,1.62,0,0,0-1.44.05l-5.81,3.36c-.43.25-.48.62-.11.84",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    className: "cls-7",
    d: "M139.4,84.33l8.18-4.68a2,2,0,0,0,.83-1.59V75.13c0-.61-.37-.89-.83-.63l-8.18,4.68a2,2,0,0,0-.83,1.59V83.7c0,.61.37.89.83.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    className: "cls-22",
    d: "M148,74.41a.86.86,0,0,1,.21.61v2.92a2,2,0,0,1-.84,1.6l-8.18,4.68a.57.57,0,0,1-.4.09.5.5,0,0,0,.62,0l8.18-4.68a2,2,0,0,0,.83-1.59V75.13c0-.42-.17-.67-.42-.72",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    className: "cls-20",
    d: "M141.86,81.15l.75-.43a.41.41,0,0,0,.18-.35v-.8c0-.13-.08-.19-.18-.14l-.75.43a.44.44,0,0,0-.18.35V81c0,.14.08.2.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    className: "cls-22",
    d: "M144.37,79.7l.75-.43a.44.44,0,0,0,.18-.35v-.8c0-.13-.08-.19-.18-.13l-.75.43a.44.44,0,0,0-.18.35v.8c0,.13.08.19.18.13",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    className: "cls-7",
    d: "M139.4,105.46l8.18-4.68a2,2,0,0,0,.83-1.59V96.26c0-.61-.37-.89-.83-.63l-8.18,4.68a2,2,0,0,0-.83,1.6v2.92c0,.61.37.89.83.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    className: "cls-22",
    d: "M148,95.54a.86.86,0,0,1,.21.61v2.92a2,2,0,0,1-.84,1.6l-8.18,4.68a.57.57,0,0,1-.4.09.5.5,0,0,0,.62,0l8.18-4.68a2,2,0,0,0,.83-1.59V96.26c0-.42-.17-.67-.42-.72",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    className: "cls-20",
    d: "M141.86,102.28l.75-.43a.41.41,0,0,0,.18-.35v-.8c0-.13-.08-.19-.18-.14l-.75.43a.45.45,0,0,0-.18.35v.8c0,.14.08.2.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    className: "cls-22",
    d: "M144.37,100.83l.75-.43a.44.44,0,0,0,.18-.35v-.8c0-.13-.08-.19-.18-.14l-.75.44a.43.43,0,0,0-.18.34v.81c0,.13.08.19.18.13",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    className: "cls-7",
    d: "M139.4,116l8.18-4.69a2,2,0,0,0,.83-1.59v-2.92c0-.62-.37-.9-.83-.63l-8.18,4.68a2,2,0,0,0-.83,1.59v2.93c0,.61.37.89.83.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    className: "cls-22",
    d: "M148,106.11a.82.82,0,0,1,.21.6v2.93a2,2,0,0,1-.84,1.59l-8.18,4.69a.62.62,0,0,1-.4.08.47.47,0,0,0,.62,0l8.18-4.68a2,2,0,0,0,.83-1.59v-2.92c0-.42-.17-.68-.42-.72",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    className: "cls-20",
    d: "M141.86,112.85l.75-.43a.41.41,0,0,0,.18-.35v-.8c0-.14-.08-.2-.18-.14l-.75.43a.44.44,0,0,0-.18.35v.8c0,.13.08.2.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    className: "cls-22",
    d: "M144.37,111.4l.75-.43a.44.44,0,0,0,.18-.35v-.8c0-.13-.08-.2-.18-.14l-.75.43a.44.44,0,0,0-.18.35v.8c0,.13.08.2.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    className: "cls-7",
    d: "M139.4,94.89l8.18-4.68a2,2,0,0,0,.83-1.59V85.7c0-.62-.37-.9-.83-.63l-8.18,4.68a2,2,0,0,0-.83,1.59v2.92c0,.62.37.9.83.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    className: "cls-22",
    d: "M148,85a.82.82,0,0,1,.21.6v2.93a2,2,0,0,1-.84,1.59l-8.18,4.69a.62.62,0,0,1-.4.08.47.47,0,0,0,.62,0l8.18-4.68a2,2,0,0,0,.83-1.59V85.7c0-.42-.17-.68-.42-.72",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    className: "cls-20",
    d: "M141.86,91.72l.75-.44a.39.39,0,0,0,.18-.34v-.8c0-.14-.08-.2-.18-.14l-.75.43a.44.44,0,0,0-.18.35v.8c0,.13.08.19.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    className: "cls-22",
    d: "M144.37,90.27l.75-.43a.44.44,0,0,0,.18-.35v-.8c0-.14-.08-.2-.18-.14l-.75.43a.44.44,0,0,0-.18.35v.8c0,.13.08.19.18.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    className: "cls-19",
    d: "M132.32,81.33,113.46,70.44a1.82,1.82,0,0,1-.77-1.46v-3.6c0-.56.34-.82.77-.57L132.32,75.7a1.85,1.85,0,0,1,.77,1.46v3.6c0,.56-.35.82-.77.57",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    className: "cls-21",
    d: "M131.78,80.07,114,69.81a.92.92,0,0,1-.39-.74V66.36c0-.28.17-.42.39-.29l17.78,10.26a1,1,0,0,1,.39.75v2.7c0,.29-.18.42-.39.29",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    className: "cls-21",
    d: "M117.7,70.58l-2.65-1.53a.94.94,0,0,1-.38-.72c0-.28.17-.41.38-.29l2.65,1.54a.86.86,0,0,1,.38.71c0,.28-.17.41-.38.29",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    className: "cls-7",
    d: "M120,71.38c0,.28-.2.39-.44.25a.94.94,0,0,1-.44-.75c0-.28.2-.39.44-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    className: "cls-7",
    d: "M121.5,72.27c0,.28-.2.39-.44.25a1,1,0,0,1-.43-.75c0-.28.19-.39.43-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    className: "cls-21",
    d: "M123,73.15c0,.28-.19.39-.43.26a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a.94.94,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    className: "cls-7",
    d: "M124.57,74c0,.28-.2.39-.44.25a1,1,0,0,1-.43-.75c0-.28.19-.39.43-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    className: "cls-7",
    d: "M131,78.57l-.89-.52a.56.56,0,0,1-.24-.46v-1c0-.17.1-.26.24-.18L131,77a.56.56,0,0,1,.24.46v1c0,.17-.1.26-.24.18",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    className: "cls-19",
    d: "M132.32,87.68,113.46,76.79a1.82,1.82,0,0,1-.77-1.46v-3.6c0-.56.34-.82.77-.58L132.32,82a1.85,1.85,0,0,1,.77,1.46v3.6c0,.56-.35.82-.77.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    className: "cls-21",
    d: "M131.78,86.42,114,76.15a.92.92,0,0,1-.39-.74V72.7c0-.28.17-.42.39-.29l17.78,10.27a.93.93,0,0,1,.39.74v2.7c0,.29-.18.42-.39.29",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    className: "cls-21",
    d: "M117.7,76.92l-2.65-1.53a.93.93,0,0,1-.38-.72c0-.28.17-.41.38-.29l2.65,1.54a.87.87,0,0,1,.38.72c0,.28-.17.4-.38.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    className: "cls-22",
    d: "M120,77.73c0,.28-.2.39-.44.25a1,1,0,0,1-.44-.76.27.27,0,0,1,.44-.25,1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    className: "cls-7",
    d: "M121.5,78.61c0,.28-.2.39-.44.25a1,1,0,0,1-.43-.75c0-.28.19-.39.43-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    className: "cls-21",
    d: "M123,79.5c0,.28-.19.39-.43.25a1,1,0,0,1-.44-.75c0-.28.2-.39.44-.25a.91.91,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    className: "cls-7",
    d: "M124.57,80.38c0,.28-.2.39-.44.25a.93.93,0,0,1-.43-.75c0-.28.19-.39.43-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    className: "cls-7",
    d: "M131,84.91l-.89-.51a.58.58,0,0,1-.24-.47V83c0-.18.1-.26.24-.19l.89.52a.57.57,0,0,1,.24.46v1c0,.18-.1.26-.24.18",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    className: "cls-19",
    d: "M132.32,94,113.46,83.13a1.82,1.82,0,0,1-.77-1.46v-3.6c0-.56.34-.82.77-.58l18.86,10.9a1.83,1.83,0,0,1,.77,1.46v3.59c0,.57-.35.83-.77.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    className: "cls-21",
    d: "M131.78,92.76,114,82.49a.91.91,0,0,1-.39-.74v-2.7c0-.29.17-.42.39-.3L131.78,89a1,1,0,0,1,.39.74v2.71c0,.28-.18.41-.39.29",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    className: "cls-21",
    d: "M117.7,83.27l-2.65-1.53a.94.94,0,0,1-.38-.72c0-.28.17-.41.38-.29l2.65,1.53a.89.89,0,0,1,.38.72c0,.28-.17.41-.38.29",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    className: "cls-22",
    d: "M120,84.07c0,.28-.2.39-.44.25a1,1,0,0,1-.44-.75c0-.28.2-.39.44-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    className: "cls-7",
    d: "M121.5,85c0,.28-.2.39-.44.25a1,1,0,0,1-.43-.76c0-.27.19-.39.43-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    className: "cls-21",
    d: "M123,85.84c0,.28-.19.39-.43.25a.94.94,0,0,1-.44-.75c0-.28.2-.39.44-.25a.94.94,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    className: "cls-7",
    d: "M124.57,86.73c0,.28-.2.39-.44.25a1,1,0,0,1-.43-.75c0-.28.19-.39.43-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    className: "cls-7",
    d: "M131,91.25l-.89-.51a.57.57,0,0,1-.24-.46v-1c0-.18.1-.26.24-.18l.89.51a.58.58,0,0,1,.24.47v.94c0,.18-.1.26-.24.19",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    className: "cls-19",
    d: "M132.32,100.37l-18.86-10.9a1.81,1.81,0,0,1-.77-1.46V84.42c0-.57.34-.83.77-.58l18.86,10.89a1.85,1.85,0,0,1,.77,1.46v3.6c0,.56-.35.82-.77.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    className: "cls-21",
    d: "M131.78,99.1,114,88.84a.92.92,0,0,1-.39-.74V85.39c0-.28.17-.42.39-.29l17.78,10.27a.93.93,0,0,1,.39.74v2.7c0,.29-.18.42-.39.29",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    className: "cls-21",
    d: "M117.7,89.61l-2.65-1.53a.94.94,0,0,1-.38-.72c0-.28.17-.41.38-.29l2.65,1.54a.86.86,0,0,1,.38.72c0,.27-.17.4-.38.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    className: "cls-7",
    d: "M120,90.41c0,.28-.2.39-.44.25a.94.94,0,0,1-.44-.75c0-.28.2-.39.44-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    className: "cls-7",
    d: "M121.5,91.3c0,.28-.2.39-.44.25a1,1,0,0,1-.43-.75c0-.28.19-.39.43-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    className: "cls-21",
    d: "M123,92.19c0,.27-.19.39-.43.25a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a.94.94,0,0,1,.43.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    className: "cls-7",
    d: "M124.57,93.07c0,.28-.2.39-.44.25a.93.93,0,0,1-.43-.75c0-.28.19-.39.43-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    className: "cls-21",
    d: "M131,97.6l-.89-.52a.57.57,0,0,1-.24-.46v-1c0-.18.1-.26.24-.18L131,96a.55.55,0,0,1,.24.46v.94c0,.18-.1.26-.24.19",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    className: "cls-19",
    d: "M132.32,106.71,113.46,95.82a1.82,1.82,0,0,1-.77-1.46v-3.6c0-.56.34-.82.77-.58l18.86,10.89a1.85,1.85,0,0,1,.77,1.46v3.6c0,.56-.35.82-.77.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    className: "cls-21",
    d: "M131.78,105.45,114,95.18a.91.91,0,0,1-.39-.74v-2.7c0-.29.17-.42.39-.3l17.78,10.27a1,1,0,0,1,.39.74v2.7c0,.29-.18.42-.39.3",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    className: "cls-21",
    d: "M117.7,96l-2.65-1.53a.93.93,0,0,1-.38-.72c0-.28.17-.41.38-.28L117.7,95a.87.87,0,0,1,.38.72c0,.28-.17.4-.38.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    className: "cls-7",
    d: "M120,96.76c0,.28-.2.39-.44.25a1,1,0,0,1-.44-.75c0-.28.2-.39.44-.26a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    className: "cls-22",
    d: "M121.5,97.64c0,.28-.2.39-.44.25a1,1,0,0,1-.43-.75c0-.28.19-.39.43-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    className: "cls-21",
    d: "M123,98.53c0,.28-.19.39-.43.25a1,1,0,0,1-.44-.75c0-.28.2-.39.44-.25a.91.91,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    className: "cls-22",
    d: "M124.57,99.41c0,.28-.2.39-.44.26a1,1,0,0,1-.43-.76c0-.28.19-.39.43-.25a1,1,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    className: "cls-21",
    d: "M131,103.94l-.89-.51a.58.58,0,0,1-.24-.47V102c0-.18.1-.26.24-.18l.89.51a.57.57,0,0,1,.24.46v1c0,.18-.1.26-.24.18",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    className: "cls-19",
    d: "M132.32,113.05l-18.86-10.89a1.82,1.82,0,0,1-.77-1.46V97.1c0-.56.34-.82.77-.58l18.86,10.9a1.83,1.83,0,0,1,.77,1.46v3.59c0,.57-.35.83-.77.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    className: "cls-21",
    d: "M131.78,111.79,114,101.52a.91.91,0,0,1-.39-.74v-2.7c0-.29.17-.42.39-.29l17.78,10.26a1,1,0,0,1,.39.74v2.71c0,.28-.18.42-.39.29",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    className: "cls-21",
    d: "M117.7,102.3l-2.65-1.54a.91.91,0,0,1-.38-.72c0-.28.17-.4.38-.28l2.65,1.53a.89.89,0,0,1,.38.72c0,.28-.17.41-.38.29",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    className: "cls-7",
    d: "M120,103.1c0,.28-.2.39-.44.25a1,1,0,0,1-.44-.75c0-.28.2-.39.44-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    className: "cls-7",
    d: "M121.5,104c0,.28-.2.39-.44.25a1,1,0,0,1-.43-.76c0-.27.19-.39.43-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    className: "cls-21",
    d: "M123,104.87c0,.28-.19.39-.43.25a.94.94,0,0,1-.44-.75c0-.28.2-.39.44-.25a.94.94,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    className: "cls-7",
    d: "M124.57,105.76c0,.28-.2.39-.44.25a1,1,0,0,1-.43-.75c0-.28.19-.39.43-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    className: "cls-7",
    d: "M131,110.28l-.89-.51a.57.57,0,0,1-.24-.46v-1c0-.18.1-.26.24-.18l.89.51a.58.58,0,0,1,.24.47v.94c0,.18-.1.26-.24.18",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    className: "cls-19",
    d: "M132.32,119.4l-18.86-10.9a1.81,1.81,0,0,1-.77-1.46v-3.59c0-.57.34-.83.77-.58l18.86,10.89a1.85,1.85,0,0,1,.77,1.46v3.6c0,.56-.35.82-.77.58",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537",
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    className: "cls-21",
    d: "M131.78,118.13,114,107.87a.92.92,0,0,1-.39-.74v-2.71c0-.28.17-.42.39-.29l17.78,10.27a.93.93,0,0,1,.39.74v2.7c0,.29-.18.42-.39.29",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    className: "cls-21",
    d: "M117.7,108.64l-2.65-1.53a.94.94,0,0,1-.38-.72c0-.28.17-.41.38-.29l2.65,1.54a.86.86,0,0,1,.38.72c0,.28-.17.4-.38.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    className: "cls-22",
    d: "M120.45,109.79c0,.52-.37.73-.82.47a1.78,1.78,0,0,1-.82-1.42c0-.53.36-.74.82-.48a1.84,1.84,0,0,1,.82,1.43",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    className: "cls-7",
    d: "M123.63,111.65c0,.28-.2.39-.44.25a1,1,0,0,1-.43-.76c0-.27.19-.39.43-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    className: "cls-21",
    d: "M125.16,112.53c0,.28-.19.39-.43.26a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.43.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    className: "cls-7",
    d: "M126.7,113.42c0,.28-.2.39-.44.25a.94.94,0,0,1-.43-.75c0-.28.19-.39.43-.25a.94.94,0,0,1,.44.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    className: "cls-21",
    d: "M131,116.63l-.89-.52a.56.56,0,0,1-.24-.46v-.94c0-.18.1-.26.24-.19l.89.52a.57.57,0,0,1,.24.46v1c0,.18-.1.26-.24.18",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    className: "cls-19",
    d: "M100.94,114.23a.27.27,0,0,1-.27-.27.28.28,0,0,1,.13-.24l3.72-2.15a1.37,1.37,0,0,0,.69-1.19v-2a.27.27,0,0,1,.27-.28.28.28,0,0,1,.28.28v2a2,2,0,0,1-1,1.67l-3.72,2.15a.32.32,0,0,1-.14,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    className: "cls-19",
    x: 96.76,
    y: 113.82,
    width: 4.89,
    height: 2.27,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -44.04, 64.59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    className: "cls-19",
    d: "M102.12,114.2a1.78,1.78,0,0,0-.79-1.39c-.45-.26-.8,0-.81.46a1.79,1.79,0,0,0,.8,1.39c.44.26.8,0,.8-.46",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    className: "cls-19",
    x: 90.66,
    y: 115.81,
    width: 7.67,
    height: 3.67,
    transform: "translate(-46 62.59) rotate(-29.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    className: "cls-20",
    d: "M97.22,114.78l1.43-.82a2.94,2.94,0,0,1,1.13,2l-1.44.82a2.92,2.92,0,0,1-1.12-2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    className: "cls-19",
    d: "M99.12,116.49a2.89,2.89,0,0,0-1.29-2.25c-.72-.41-1.3-.08-1.3.75a2.84,2.84,0,0,0,1.29,2.25c.71.41,1.3.08,1.3-.75",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    className: "cls-21",
    d: "M100.79,113.67a.23.23,0,0,0,.14-.29.24.24,0,0,0-.14-.14.85.85,0,0,0-.76,0,.23.23,0,0,0-.14.29.22.22,0,0,0,.14.14.85.85,0,0,0,.76,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    className: "cls-7",
    d: "M83.23,159.37l-46.82-27c-1.33-.77-1.16-2.11.37-3L68.66,111a5.74,5.74,0,0,1,5.17-.21l46.82,27c1.32.76,1.16,2.1-.37,3L88.4,159.15a5.74,5.74,0,0,1-5.17.22",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    className: "cls-19",
    d: "M94.53,158.08a.25.25,0,0,1-.14,0l-9-5.3a.28.28,0,0,1-.08-.38.27.27,0,0,1,.36-.09l9,5.3a.27.27,0,0,1-.14.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    className: "cls-7",
    d: "M121.54,132.72l-6.4-.84L73.83,108a5.77,5.77,0,0,0-5.17.22L39.39,125.13l-3.87-.51v2.2h0a1.5,1.5,0,0,0,.89,1.35l46.82,27A5.74,5.74,0,0,0,88.4,155l31.88-18.4a2.08,2.08,0,0,0,1.26-1.74Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    className: "cls-20",
    d: "M90.5,117.65,87.57,116H55.3l-15.91,9.18-3.87-.51v2.2h0a1.5,1.5,0,0,0,.89,1.35l46.82,27a4.74,4.74,0,0,0,2.67.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    className: "cls-19",
    d: "M37.23,124.85l-1.71-.23v2.2h0a1.5,1.5,0,0,0,.89,1.35l.82.48Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    className: "cls-42",
    d: "M83.7,155.42a6,6,0,0,0,4.39-.27v-4.9H83.7Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    className: "cls-21",
    d: "M83.23,153,36.41,126c-1.33-.76-1.16-2.1.37-3l31.88-18.4a5.74,5.74,0,0,1,5.17-.22l46.82,27c1.32.77,1.16,2.1-.37,3L88.4,152.8a5.74,5.74,0,0,1-5.17.21",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    className: "cls-22",
    d: "M120.28,133.6,88.4,152a5.77,5.77,0,0,1-5.17.21l-46.82-27a1.68,1.68,0,0,1-.82-.9,1.41,1.41,0,0,0,.82,1.7l46.82,27a5.74,5.74,0,0,0,5.17-.21l31.88-18.4c1-.6,1.44-1.39,1.19-2.09a2.5,2.5,0,0,1-1.19,1.29",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    className: "cls-7",
    d: "M56.32,117l-2.12-1.22c-.17-.1-.14-.27,0-.38l2.5-1.45a.79.79,0,0,1,.67,0l2.11,1.23c.17.09.15.27,0,.38L57,117a.72.72,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    className: "cls-7",
    d: "M59.59,118.92l-2.11-1.22c-.17-.1-.15-.27,0-.39l2.5-1.44a.79.79,0,0,1,.67,0l2.11,1.23c.17.09.15.26,0,.38l-2.5,1.44a.72.72,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    className: "cls-7",
    d: "M62.87,120.81l-2.12-1.22c-.17-.1-.15-.27,0-.39l2.5-1.44a.75.75,0,0,1,.67,0L66.08,119c.17.1.14.27,0,.39l-2.5,1.44a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    className: "cls-7",
    d: "M67.39,119.25,65.27,118c-.17-.1-.15-.27,0-.39l2.1-1.21a.76.76,0,0,1,.66,0l2.12,1.23c.17.09.15.27,0,.38l-2.1,1.21a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    className: "cls-7",
    d: "M70.66,121.14l-2.12-1.23c-.17-.09-.15-.26,0-.38l2.1-1.21a.76.76,0,0,1,.66,0l2.12,1.23c.17.09.15.27,0,.38l-2.09,1.21a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    className: "cls-7",
    d: "M73.93,123l-2.12-1.23c-.17-.09-.14-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.39L74.6,123a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    className: "cls-7",
    d: "M77.2,124.92l-2.11-1.23c-.17-.1-.15-.27,0-.38l2.1-1.21a.72.72,0,0,1,.67,0L80,123.29c.17.1.15.27,0,.39l-2.1,1.21a.77.77,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    className: "cls-7",
    d: "M80.48,126.8l-2.12-1.22c-.17-.1-.15-.27,0-.38L80.5,124a.72.72,0,0,1,.67,0l2.12,1.22c.17.1.15.27-.05.38l-2.1,1.22a.73.73,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    className: "cls-7",
    d: "M83.75,128.69l-2.12-1.22c-.17-.1-.15-.27.05-.38l2.09-1.21a.72.72,0,0,1,.67,0l2.12,1.22c.17.1.15.27,0,.38l-2.1,1.22a.73.73,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    className: "cls-7",
    d: "M87,130.58l-2.12-1.22c-.17-.1-.15-.27,0-.38l2.1-1.22a.73.73,0,0,1,.66,0L89.83,129c.17.1.15.27,0,.38l-2.1,1.21a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    className: "cls-7",
    d: "M90.29,132.47l-2.12-1.22c-.17-.1-.15-.27,0-.39l2.1-1.21a.73.73,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38L91,132.44a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    className: "cls-7",
    d: "M93.56,134.36l-2.12-1.22c-.17-.1-.14-.27,0-.39l2.1-1.21a.76.76,0,0,1,.66,0l2.12,1.23c.17.1.15.27,0,.38l-2.1,1.21a.72.72,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    className: "cls-7",
    d: "M96.83,136.25,94.72,135c-.17-.1-.15-.27,0-.39l2.1-1.21a.77.77,0,0,1,.66,0l2.12,1.23c.17.09.15.27,0,.38l-2.1,1.21a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    className: "cls-20",
    d: "M72.21,118.36l-2.12-1.23c-.17-.1-.15-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0L75,116.73c.17.1.15.27,0,.39l-2.1,1.21a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    className: "cls-20",
    d: "M68.89,116.44l-2.12-1.23c-.17-.09-.15-.26,0-.38l2.1-1.21a.76.76,0,0,1,.66,0l2.12,1.23c.17.09.15.27,0,.38l-2.1,1.21a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    className: "cls-7",
    d: "M65.56,114.52,61,111.88c-.17-.09-.15-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0l4.56,2.64c.17.09.15.26-.05.38l-2.09,1.21a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    className: "cls-7",
    d: "M67.89,112.18,64.19,110c-.17-.09-.15-.27,0-.38l2.1-1.21a.75.75,0,0,1,.67,0l3.7,2.14c.17.1.15.27,0,.38l-2.1,1.21a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    className: "cls-20",
    d: "M75.48,120.24,73.36,119c-.17-.1-.14-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-2.1,1.22a.75.75,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    className: "cls-7",
    d: "M78.75,122.13l-2.12-1.22c-.17-.1-.14-.27.05-.38l2.1-1.22a.73.73,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-2.1,1.21a.72.72,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    className: "cls-7",
    d: "M82,124l-2.12-1.22c-.17-.1-.15-.27,0-.39l2.1-1.21a.75.75,0,0,1,.67,0l2.11,1.22c.17.1.15.27,0,.38L82.69,124a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    className: "cls-7",
    d: "M85.3,125.91l-2.12-1.22c-.17-.1-.15-.27,0-.39l2.1-1.21a.79.79,0,0,1,.67,0l2.12,1.23c.17.1.14.27,0,.38L86,125.88a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    className: "cls-7",
    d: "M88.57,127.8l-2.12-1.22c-.17-.1-.15-.27,0-.39L88.6,125a.76.76,0,0,1,.66,0l2.12,1.23c.17.09.15.27,0,.38l-2.1,1.21a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    className: "cls-7",
    d: "M91.84,129.69l-2.12-1.23c-.17-.09-.15-.26,0-.38l2.1-1.21a.76.76,0,0,1,.66,0l2.12,1.23c.17.09.15.27-.05.38l-2.1,1.21a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    className: "cls-7",
    d: "M95.11,131.58,93,130.35c-.17-.09-.15-.27.05-.38l2.1-1.21a.7.7,0,0,1,.66,0L97.92,130c.17.1.15.27,0,.39l-2.1,1.21a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    className: "cls-7",
    d: "M98.38,133.47l-2.12-1.23c-.17-.1-.14-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.39l-2.09,1.21a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    className: "cls-7",
    d: "M101.65,135.35l-2.11-1.22c-.17-.1-.15-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.39l-2.1,1.21a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    className: "cls-7",
    d: "M107.47,138.71,102.85,136c-.17-.09-.15-.27,0-.38l2.1-1.21a.72.72,0,0,1,.67,0l4.62,2.67c.17.1.15.27,0,.38l-2.1,1.21a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    className: "cls-7",
    d: "M113.84,135l-3.9-2.25c-.17-.1-.15-.27,0-.38l2.1-1.21a.72.72,0,0,1,.67,0l3.9,2.25c.17.1.15.27-.05.38L114.5,135a.73.73,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    className: "cls-7",
    d: "M81.21,119.87l-2.12-1.22c-.17-.1-.15-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0L84,118.25c.17.1.15.27,0,.38l-2.1,1.22a.73.73,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    className: "cls-7",
    d: "M77.86,117.94l-2.12-1.22c-.17-.1-.15-.27.05-.39l2.1-1.21a.76.76,0,0,1,.66,0l2.12,1.23c.17.09.15.27,0,.38l-2.1,1.21a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    className: "cls-20",
    d: "M74.51,116l-2.12-1.22c-.17-.1-.15-.27,0-.38l2.1-1.22a.75.75,0,0,1,.67,0l2.11,1.22c.17.1.15.27,0,.38L75.17,116a.73.73,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    className: "cls-7",
    d: "M71.15,114.07,69,112.84c-.17-.09-.14-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0L74,112.44c.17.1.15.27,0,.39L71.82,114a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    className: "cls-7",
    d: "M84.48,121.76l-2.12-1.22c-.17-.1-.14-.27,0-.38l2.1-1.22a.73.73,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-2.1,1.22a.75.75,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    className: "cls-7",
    d: "M87.75,123.65l-2.11-1.22c-.17-.1-.15-.27,0-.38l2.1-1.22a.73.73,0,0,1,.66,0L90.56,122c.17.1.15.27,0,.38l-2.1,1.21a.72.72,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    className: "cls-7",
    d: "M91,125.54l-2.12-1.22c-.17-.1-.15-.27,0-.39l2.1-1.21a.79.79,0,0,1,.67,0l2.11,1.23c.17.1.15.27,0,.38l-2.1,1.21a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    className: "cls-7",
    d: "M94.3,127.43l-2.12-1.22c-.17-.1-.15-.27,0-.39l2.09-1.21a.79.79,0,0,1,.67,0l2.12,1.23c.17.1.15.27,0,.38L95,127.4a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    className: "cls-7",
    d: "M97.57,129.32l-2.12-1.22c-.17-.1-.15-.27,0-.39l2.1-1.21a.76.76,0,0,1,.66,0l2.12,1.23c.17.09.15.27,0,.38l-2.1,1.21a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    className: "cls-7",
    d: "M100.84,131.21,98.72,130c-.17-.09-.15-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27-.05.39l-2.1,1.21a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    className: "cls-7",
    d: "M104.11,133.1,102,131.87c-.17-.1-.14-.27.05-.38l2.1-1.21a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.39l-2.1,1.21a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    className: "cls-7",
    d: "M107.38,135l-2.12-1.22c-.17-.1-.14-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-2.1,1.22a.75.75,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    className: "cls-7",
    d: "M110.65,136.87l-2.11-1.22c-.17-.1-.15-.27,0-.38l2.1-1.21a.72.72,0,0,1,.67,0l2.11,1.22c.17.1.15.27,0,.38l-2.1,1.22a.75.75,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    className: "cls-7",
    d: "M79.49,115.2,77.37,114c-.17-.1-.15-.27,0-.38l2.1-1.22a.73.73,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-2.1,1.21a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    className: "cls-7",
    d: "M76.23,113.32l-2.12-1.22c-.17-.1-.14-.27,0-.38l2.1-1.22a.73.73,0,0,1,.66,0L79,111.7c.17.1.15.27,0,.38l-2.1,1.22a.75.75,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    className: "cls-7",
    d: "M73,111.44l-2.12-1.22c-.17-.1-.15-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27-.05.38l-2.1,1.22a.73.73,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    className: "cls-7",
    d: "M69.72,109.56l-2.11-1.22c-.17-.1-.15-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-2.1,1.22a.75.75,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    className: "cls-7",
    d: "M73.07,107.63,71,106.41c-.17-.1-.15-.27,0-.38l.69-.41a.75.75,0,0,1,.67,0l2.11,1.22c.17.1.15.27,0,.38l-.7.4a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    className: "cls-7",
    d: "M77.32,110.08l-2.12-1.22c-.17-.1-.15-.27,0-.38l.69-.4a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.39l-.7.4a.73.73,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    className: "cls-7",
    d: "M80.56,112l-2.12-1.23c-.17-.1-.15-.27,0-.38l.69-.4a.75.75,0,0,1,.67,0L82,111.14c.17.1.15.27,0,.39l-.7.4a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    className: "cls-7",
    d: "M83.8,113.83l-2.12-1.23c-.17-.09-.15-.27,0-.38l.69-.4a.79.79,0,0,1,.67,0L85.2,113c.17.09.15.27,0,.38l-.7.4a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    className: "cls-7",
    d: "M87,115.7l-2.12-1.22c-.17-.1-.14-.27,0-.39l.69-.4a.79.79,0,0,1,.67,0l2.12,1.23c.17.1.15.27,0,.38l-.69.4a.72.72,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    className: "cls-7",
    d: "M105.14,126.15,103,124.92c-.17-.09-.15-.27,0-.38l.69-.4a.79.79,0,0,1,.67,0l2.11,1.23c.18.09.15.27,0,.38l-.7.4a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    className: "cls-7",
    d: "M108.38,128l-2.12-1.23c-.17-.09-.14-.27,0-.38l.69-.4a.79.79,0,0,1,.67,0l2.12,1.23c.17.09.15.27-.05.38l-.69.4a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    className: "cls-7",
    d: "M111.62,129.89l-2.11-1.22c-.17-.1-.15-.27,0-.39l.7-.4a.73.73,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-.69.4a.72.72,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    className: "cls-7",
    d: "M114.87,131.76l-2.12-1.22c-.17-.1-.15-.27,0-.38l.7-.4a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-.69.4a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    className: "cls-7",
    d: "M82.76,117.09l-2.12-1.22c-.17-.1-.15-.27,0-.39l2.1-1.21a.73.73,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-2.1,1.21a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    className: "cls-7",
    d: "M86,119l-2.12-1.22c-.17-.1-.15-.27,0-.39l2.1-1.21a.76.76,0,0,1,.66,0l2.12,1.23c.17.1.15.27,0,.38L86.7,119a.72.72,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    className: "cls-7",
    d: "M89.3,120.87l-2.12-1.22c-.17-.1-.14-.27,0-.39l2.1-1.21a.76.76,0,0,1,.66,0l2.12,1.23c.17.09.15.27,0,.38L90,120.84a.72.72,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    className: "cls-7",
    d: "M92.57,122.76l-2.11-1.23c-.17-.09-.15-.27,0-.38l2.1-1.21a.79.79,0,0,1,.67,0l2.11,1.23c.17.09.15.26,0,.38l-2.1,1.21a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    className: "cls-7",
    d: "M95.85,124.65l-2.12-1.23c-.17-.09-.15-.27,0-.38l2.1-1.21a.72.72,0,0,1,.67,0L98.66,123c.16.1.14.27,0,.39l-2.1,1.21a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    className: "cls-7",
    d: "M99.12,126.53,97,125.31c-.17-.1-.15-.27,0-.38l2.09-1.21a.72.72,0,0,1,.67,0l2.12,1.22c.17.1.15.27-.05.39l-2.1,1.21a.73.73,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    className: "cls-7",
    d: "M102.39,128.42l-2.12-1.22c-.17-.1-.15-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-2.1,1.22a.73.73,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    className: "cls-7",
    d: "M105.66,130.31l-2.12-1.22c-.17-.1-.15-.27,0-.38l2.1-1.21a.7.7,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-2.1,1.22a.75.75,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    className: "cls-7",
    d: "M108.93,132.2,106.81,131c-.17-.1-.15-.27,0-.38l2.1-1.22a.73.73,0,0,1,.66,0l2.12,1.22c.17.1.15.27,0,.38l-2.09,1.21a.72.72,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    className: "cls-7",
    d: "M64.06,117.32l-6.24-3.6c-.17-.1-.15-.27,0-.38l2.1-1.21a.72.72,0,0,1,.67,0l6.24,3.6c.16.1.14.27-.05.38l-2.1,1.22a.73.73,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    className: "cls-7",
    d: "M104.25,140.53,98,136.93c-.17-.1-.15-.27,0-.39l2.1-1.21a.79.79,0,0,1,.67,0l6.24,3.61c.17.09.15.27,0,.38l-2.1,1.21a.7.7,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    className: "cls-7",
    d: "M91.16,137.15l-2.11-1.23c-.17-.09-.15-.27,0-.38l2.5-1.44a.72.72,0,0,1,.67,0l2.11,1.22c.17.1.15.27,0,.39l-2.5,1.44a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    className: "cls-7",
    d: "M67.41,123.43l-3.39-2c-.17-.1-.15-.27,0-.39l2.5-1.44a.76.76,0,0,1,.66,0l3.39,2c.17.1.15.27-.05.38l-2.5,1.45a.73.73,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    className: "cls-7",
    d: "M88,135.33l-3.39-2c-.17-.1-.14-.27,0-.38l2.5-1.45a.75.75,0,0,1,.67,0l3.38,1.95c.17.1.15.27,0,.39l-2.5,1.44a.79.79,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    className: "cls-7",
    d: "M72.13,126.16l-3.39-2c-.17-.1-.15-.27.05-.38l2.5-1.45a.76.76,0,0,1,.66,0l3.39,2c.17.1.15.27,0,.38l-2.5,1.45a.76.76,0,0,1-.66,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    className: "cls-7",
    d: "M72,122.36l14.73,8.5a.2.2,0,0,1,.13.26.21.21,0,0,1-.13.13l-2.55,1.47a.76.76,0,0,1-.66,0l-14.73-8.51Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    className: "cls-7",
    d: "M100.31,140.57l2.36,1.36c.14.08.12.23,0,.32l-1,.59a.62.62,0,0,1-.55,0L98.7,141.5c-.14-.08-.12-.22,0-.31l1-.6a.62.62,0,0,1,.55,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    className: "cls-7",
    d: "M97,138.67,99.37,140c.14.08.12.22,0,.31l-1,.59a.59.59,0,0,1-.55,0l-2.36-1.37c-.14-.08-.12-.22,0-.31l1-.59a.6.6,0,0,1,.54,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    className: "cls-7",
    d: "M93.74,136.78l2.36,1.36c.14.08.12.22,0,.31l-1,.6a.62.62,0,0,1-.55,0l-2.36-1.36c-.14-.08-.12-.23,0-.32l1-.59a.62.62,0,0,1,.55,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    className: "cls-7",
    d: "M98.82,137.62l2.36,1.37c.14.08.12.22,0,.31l-1,.59a.6.6,0,0,1-.54,0l-2.36-1.36c-.14-.08-.12-.22,0-.31l1-.59a.63.63,0,0,1,.55,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    className: "cls-19",
    d: "M71.05,142.84a2,2,0,0,1-1-.23l-16.35-9.44a.83.83,0,0,1-.47-.72,1,1,0,0,1,.61-.87l10.82-6.25a2.47,2.47,0,0,1,2.23-.08l16.35,9.44a.83.83,0,0,1,.47.72,1,1,0,0,1-.61.87L72.3,142.53a2.69,2.69,0,0,1-1.25.31m-5.12-17.31a2,2,0,0,0-1,.25L54.11,132c-.22.13-.35.28-.35.42a.34.34,0,0,0,.21.27l16.36,9.45a1.91,1.91,0,0,0,1.71-.09l10.83-6.25c.22-.12.35-.28.35-.42a.35.35,0,0,0-.21-.27L66.66,125.7a1.57,1.57,0,0,0-.73-.17",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    className: "cls-22",
    d: "M67.28,132.55l1.6-.89a.63.63,0,0,1,.58,0c.17.1.19.25,0,.33l-1.6.9a.66.66,0,0,1-.58,0c-.17-.1-.19-.24,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    className: "cls-22",
    d: "M63.87,134.46l2.37-1.32a.66.66,0,0,1,.58,0c.17.1.19.25,0,.33l-2.36,1.33a.66.66,0,0,1-.58,0c-.18-.1-.19-.25-.05-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    className: "cls-22",
    d: "M72.58,135.5l3.06-1.72a.66.66,0,0,1,.58,0c.17.1.19.25,0,.33l-3.06,1.72a.66.66,0,0,1-.58,0c-.17-.1-.19-.25,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    className: "cls-22",
    d: "M72,132.85l1-.56a.66.66,0,0,1,.58,0c.17.09.19.24,0,.33l-1,.56a.66.66,0,0,1-.58,0c-.17-.1-.19-.25,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    className: "cls-22",
    d: "M69.78,131.15l.64-.36a.66.66,0,0,1,.58,0c.17.1.19.25,0,.33l-.64.36a.66.66,0,0,1-.58,0c-.17-.1-.19-.24,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    className: "cls-22",
    d: "M67,129.74l.8-.44a.69.69,0,0,1,.58,0c.17.1.19.25,0,.33l-.8.45a.66.66,0,0,1-.58,0c-.17-.1-.19-.24,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    className: "cls-22",
    d: "M63.91,131.48,66,130.3a.66.66,0,0,1,.58,0c.17.1.19.25,0,.33l-2.1,1.18a.66.66,0,0,1-.58,0c-.17-.1-.19-.24,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    className: "cls-22",
    d: "M65,129.4l1.51-.85a.66.66,0,0,1,.58,0c.18.1.2.24,0,.33l-1.52.84a.63.63,0,0,1-.58,0c-.17-.1-.19-.25,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    className: "cls-22",
    d: "M68.3,134.94l2.68-1.5a.66.66,0,0,1,.58,0c.17.09.19.24,0,.32l-2.67,1.5a.69.69,0,0,1-.58,0c-.18-.1-.19-.25,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    className: "cls-22",
    d: "M69.67,135.65,74.34,133a.63.63,0,0,1,.58,0c.17.1.19.25,0,.33L70.3,136a.62.62,0,0,1-.58,0c-.18-.1-.19-.25,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    className: "cls-22",
    d: "M69.05,133l2.67-1.5a.68.68,0,0,1,.59,0c.17.1.19.25,0,.33l-2.68,1.5a.66.66,0,0,1-.58,0c-.17-.1-.19-.25,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    className: "cls-22",
    d: "M66.28,136.07l1-.54a.66.66,0,0,1,.58,0c.17.09.19.24,0,.33l-1,.54a.66.66,0,0,1-.58,0c-.17-.1-.19-.24,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    className: "cls-22",
    d: "M65.9,131.85,69.11,130a.68.68,0,0,1,.59,0c.17.1.19.25,0,.33l-3.22,1.8a.66.66,0,0,1-.58,0c-.17-.1-.19-.24,0-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    className: "cls-19",
    d: "M113.62,113a2.07,2.07,0,0,1-1-.28l-14.43-8.35a1.46,1.46,0,0,1-.53-2,1.39,1.39,0,0,1,.51-.51l4-2.42a.27.27,0,0,1,.38.08.28.28,0,0,1-.08.38h0l-4,2.41a.91.91,0,0,0-.31,1.25.82.82,0,0,0,.33.31l14.42,8.35a1.51,1.51,0,0,0,1.56,0l5-3a.27.27,0,0,1,.37.09.28.28,0,0,1-.09.38l-5,3a2.12,2.12,0,0,1-1.09.31",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    className: "cls-7",
    d: "M76.59,96.64l-5.75-3.32-5.75,3.32L70.84,100Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    className: "cls-9",
    d: "M72.51,92.24V71.56l4.88-2.82V89.42Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    className: "cls-10",
    d: "M72.51,71.56l-4.88-2.82V89.41l4.88,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    className: "cls-11",
    d: "M77.39,68.74l-4.88-2.82-4.88,2.82,4.88,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    className: "cls-12",
    d: "M77.39,93.18l-4.88-2.82v1.88l4.88,2.81Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    className: "cls-13",
    d: "M67.63,95.06V80l4.88-2.82v15Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    className: "cls-14",
    d: "M67.63,80,62.74,77.2v15l4.89,2.81Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    className: "cls-15",
    d: "M72.51,77.2l-4.88-2.82L62.74,77.2,67.63,80Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    className: "cls-16",
    d: "M67.63,95.06V80l4.88-2.82v15Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    className: "cls-16",
    d: "M67.63,80,62.74,77.2v15l4.89,2.81Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    className: "cls-4",
    d: "M72.51,77.2l-4.88-2.82L62.74,77.2,67.63,80Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    className: "cls-17",
    d: "M72.51,97.87V89.41l4.88-2.82v8.46Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    className: "cls-18",
    d: "M72.51,89.42,67.63,86.6v8.46l4.88,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    className: "cls-3",
    d: "M77.39,86.6l-4.88-2.83-4.88,2.82,4.88,2.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    className: "cls-7",
    d: "M122.58,78.74A1.37,1.37,0,0,0,121,79a7.59,7.59,0,0,0-1.51,3.71c0,1.19.94,1.11,1.52.83a10.9,10.9,0,0,0,2.37-3.21,1.72,1.72,0,0,0-.29-1.26,5.31,5.31,0,0,0-.48-.32",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    className: "cls-21",
    d: "M122.8,78.5l0,1a.57.57,0,0,1-.29.54,1.13,1.13,0,0,1-.77.12c-.75-.12-.81-.33-.87-1.37s1.89-.32,1.89-.32",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    className: "cls-7",
    d: "M118.93,76.75a1.37,1.37,0,0,0-1.61.25,7.63,7.63,0,0,0-1.51,3.71c0,1.19.94,1.11,1.52.83a10.6,10.6,0,0,0,2.37-3.21,1.67,1.67,0,0,0-.28-1.25c-.17-.13-.49-.32-.49-.32",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    className: "cls-21",
    d: "M119.15,76.51l0,1a.58.58,0,0,1-.3.53,1.08,1.08,0,0,1-.77.12c-.75-.12-.81-.33-.87-1.36s1.89-.33,1.89-.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    className: "cls-3",
    d: "M128,57.56c-.29-4.8-5.2.7-5.2.7l-3.35,3.29-3,3.32a3,3,0,0,0-.76,2.4l1.23,9.3a.92.92,0,0,0,.91.8,3.42,3.42,0,0,0,.46,0,1.15,1.15,0,0,0,1-1.21l-.23-8.71,6.35-3.82s2.9-1.24,2.6-6",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    className: "cls-3",
    d: "M131.69,59.38c-.29-4.8-5.2.71-5.2.71l-3.35,3.29-3,3.32a3,3,0,0,0-.76,2.39l1.23,9.31a.92.92,0,0,0,.91.8l.46,0A1.15,1.15,0,0,0,123,78l-.23-8.71,6.35-3.82s2.9-1.24,2.6-6",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    className: "cls-44",
    d: "M128.79,44c3.72,1.54,3.64,3.73,3.64,3.73A127.18,127.18,0,0,0,132,61.15c.11,2.25-11.95,2.42-10.15-3.58,2.12-7.08,1.33-12.8,2.32-13.67s3.71-.32,4.67.07",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    className: "cls-45",
    d: "M130,45.92a1.72,1.72,0,0,1-2.21.89c-1-.26-1.7-1.09-1.51-1.84a1.72,1.72,0,0,1,2.21-.89c1,.26,1.7,1.09,1.51,1.84",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    className: "cls-22",
    d: "M128.41,47.07a2.65,2.65,0,0,1-.68-.09,2.47,2.47,0,0,1-1.3-.8,1.34,1.34,0,0,1,0-1.9A1.53,1.53,0,0,1,127,44a2.63,2.63,0,0,1,2.83.73,1.35,1.35,0,0,1,0,1.9,1.24,1.24,0,0,1-.53.31,2.25,2.25,0,0,1-.85.16m-.56-2.9a2,2,0,0,0-.72.14,1,1,0,0,0-.68,1.22,1.06,1.06,0,0,0,.26.43,2.24,2.24,0,0,0,2.42.62,1.07,1.07,0,0,0,.69-.7h0a1.09,1.09,0,0,0-.26-1,2.15,2.15,0,0,0-1.12-.68,2.33,2.33,0,0,0-.59-.08",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    className: "cls-45",
    d: "M127.3,43.81a9.7,9.7,0,0,1,0,1.32c0,.38,1.27.72,1.61.38s.2-.68.28-1.94-1.86.24-1.86.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    className: "cls-46",
    d: "M129.16,43.57a2.62,2.62,0,0,1-1.89,1.62l0-1.06Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    className: "cls-45",
    d: "M130.16,40.6A2.86,2.86,0,1,1,124.62,42a2.85,2.85,0,0,1,2-3.48h0a2.86,2.86,0,0,1,3.49,2.05",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    className: "cls-46",
    d: "M128.05,41.42a8.84,8.84,0,0,1-2.67.69c-1.09,0-.85-.91-.85-.91l3.24-.47Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    className: "cls-4",
    d: "M125.05,41.6a5.18,5.18,0,0,1,2.58-.34,1.3,1.3,0,0,1,.73.43.4.4,0,0,0,.22.16c.21,0,.56-.83,1-.86s.7.28.36.82-.23,1.16-.07,1.24,1.81-1.18.35-4.08-5.19-1.34-5.76-.75c0,0-.61.53-1.11.06,0,0-.56,4.16,1.73,3.32",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    className: "cls-45",
    d: "M130.35,53.6v2.18a.89.89,0,0,1-.29.65l-4.47,4.08.51.78,5.9-3.87a1.24,1.24,0,0,0,.49-.85l.4-4.21Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    className: "cls-44",
    d: "M132.12,46.62s1.36,2,1.86,7.42a7.71,7.71,0,0,1-3.63.32c-1.32-.42,1.77-7.73,1.77-7.73",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    className: "cls-47",
    d: "M130.1,49.2a39.55,39.55,0,0,0-.56,4.18.87.87,0,0,0,.56.83Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    className: "cls-7",
    d: "M128.94,63.34l-1-.13-6.38-3.68a.87.87,0,0,0-.8,0l-4.52,2.61-.6-.08v.59h0a.24.24,0,0,0,.14.21L123,67.07a.91.91,0,0,0,.79,0l4.93-2.85a.31.31,0,0,0,.19-.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    className: "cls-20",
    d: "M124.15,61l-.46-.26h-5l-2.46,1.42-.6-.08v.59h0a.25.25,0,0,0,.14.21L123,67.07a.82.82,0,0,0,.41.08Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    className: "cls-19",
    d: "M115.92,62.12l-.27,0v.59h0a.24.24,0,0,0,.14.21l.13.08Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    className: "cls-42",
    d: "M123.1,67.1a.91.91,0,0,0,.67,0v-1h-.67Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    className: "cls-22",
    d: "M123,66.47l-7.24-4.17c-.2-.12-.17-.33.06-.46L120.77,59a.9.9,0,0,1,.8,0l7.23,4.18c.21.12.18.32-.05.46l-4.93,2.84a.87.87,0,0,1-.8,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    className: "cls-21",
    d: "M122.9,65.84l-6-3.47c-.17-.1-.15-.27,0-.38l2.64-1.49a.79.79,0,0,1,.67,0l6,3.48c.17.09.15.27,0,.38l-2.63,1.48a.72.72,0,0,1-.67,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    className: "cls-45",
    d: "M121.05,58.86l-.07.5a3.67,3.67,0,0,0,0,1.28l.09.44a.61.61,0,0,0,.5.48.32.32,0,0,0,.39-.27v0l.11-1.07s.28.36.41.36-.15-1.07-.45-1.68-1,0-1,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    className: "cls-45",
    d: "M123.5,50.93l-.77,1.53a3,3,0,0,0-.32,1.17l-.34,5.25-1,0-.46-5.9a2,2,0,0,1,0-.55l.53-3Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    className: "cls-7",
    d: "M122.78,66.87l-.61-.79-6.37-3.69a.86.86,0,0,1-.37-.71V56.46l-.36-.47.34-.2h0a.23.23,0,0,1,.25,0L122.89,60a.91.91,0,0,1,.37.71v5.69a.32.32,0,0,1-.13.3Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    className: "cls-20",
    d: "M118.37,63.88l-.45-.26-2.49-4.32V56.46l-.36-.47.34-.2h0a.23.23,0,0,1,.25,0L122.89,60a.76.76,0,0,1,.27.32Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    className: "cls-19",
    d: "M115.23,56.2l-.16-.22.34-.19h0a.23.23,0,0,1,.25,0l.13.07Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    className: "cls-42",
    d: "M123,60a.89.89,0,0,1,.3.61l-.7.41-.34-.59Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    className: "cls-22",
    d: "M122.54,60.18,115.32,56c-.21-.12-.38,0-.38.28V62a.87.87,0,0,0,.37.71l7.22,4.19c.21.11.38,0,.38-.28V60.89a.89.89,0,0,0-.37-.71",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    className: "cls-45",
    d: "M126.1,61.29l-.12.24a1.68,1.68,0,0,1-.6.67l-.72.44a.75.75,0,0,1-.74,0l0,0a.42.42,0,0,1-.11-.6l0-.06.75-.77s-.42.32-.54.19.41-.56.79-.58a1.51,1.51,0,0,0,.75-.31Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    className: "cls-44",
    d: "M124.19,43.89a23.35,23.35,0,0,0-3.85,5.74A5.57,5.57,0,0,0,123.58,52c2.3.66.61-8.1.61-8.1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    className: "cls-47",
    d: "M123.06,51.81l.44-4.31-1,4a6.65,6.65,0,0,0,.61.27",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    className: "cls-22",
    d: "M126.25,43.29l-.74-.21a1.81,1.81,0,0,0,.87.7c.52.14.6-.29.6-.29Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    className: "cls-7",
    d: "M44.25,114.33,36,109.56c-.5-.29-.44-.8.15-1.14l8-4.6a2.19,2.19,0,0,1,2-.08l8.25,4.76c.51.3.44.81-.14,1.15l-8,4.6a2.26,2.26,0,0,1-2,.08",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    className: "cls-20",
    d: "M57.08,104.88h0v-3.57h-8l-2.76-1.6a2.76,2.76,0,0,0-2.47.1l-2.58,1.49h-8V105a.71.71,0,0,0,.42.67l10.33,6a2.78,2.78,0,0,0,2.48-.1l10-5.76a1,1,0,0,0,.61-.85",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    className: "cls-20",
    d: "M45.17,99.47a2.83,2.83,0,0,0-1.33.34l-2.57,1.49h-8V105a.71.71,0,0,0,.42.67l10.33,6a2.3,2.3,0,0,0,1.15.25Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    className: "cls-19",
    d: "M34.17,101.3h-.9V105a.71.71,0,0,0,.42.66l.48.28Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    className: "cls-19",
    d: "M44.18,111.67a2.87,2.87,0,0,0,2,0v-4.16h-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    className: "cls-21",
    d: "M44,107.94l-10.33-6c-.63-.36-.55-1,.18-1.42l10-5.76a2.73,2.73,0,0,1,2.47-.11l10.33,6c.64.37.56,1-.17,1.43l-10,5.76a2.76,2.76,0,0,1-2.47.1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    className: "cls-19",
    d: "M44.21,106.87l-8.66-5c-.53-.31-.46-.85.15-1.2l8.36-4.83a2.32,2.32,0,0,1,2.07-.08l8.66,5c.53.3.47.84-.15,1.19l-8.36,4.83a2.29,2.29,0,0,1-2.07.09",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    className: "cls-21",
    d: "M53.28,105.82a1,1,0,0,1-.42.72c-.23.13-.42,0-.42-.24a.93.93,0,0,1,.42-.72c.23-.14.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    className: "cls-21",
    d: "M54.62,105a.91.91,0,0,1-.42.72c-.23.14-.42,0-.42-.24a.93.93,0,0,1,.42-.72c.23-.13.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    className: "cls-21",
    d: "M56,104.27a.9.9,0,0,1-.42.72c-.23.13-.41,0-.41-.24a.9.9,0,0,1,.41-.72c.23-.14.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    className: "cls-20",
    d: "M57.08,99.18h0V95.61h-8L46.32,94a2.75,2.75,0,0,0-2.48.1l-2.57,1.49h-8v3.67a.73.73,0,0,0,.43.66l10.33,6a2.75,2.75,0,0,0,2.48-.1l10-5.76a1,1,0,0,0,.61-.85",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    className: "cls-20",
    d: "M45.17,93.77a3,3,0,0,0-1.33.35l-2.57,1.49h-8v3.67a.71.71,0,0,0,.42.66l10.33,6a2.29,2.29,0,0,0,1.15.24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    className: "cls-19",
    d: "M34.17,95.6h-.9v3.67a.71.71,0,0,0,.42.66l.48.28Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    className: "cls-19",
    d: "M44.18,106a2.76,2.76,0,0,0,2,0v-4.16h-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    className: "cls-21",
    d: "M44,102.24l-10.33-6c-.63-.37-.55-1,.18-1.43l10-5.76a2.76,2.76,0,0,1,2.47-.1l10.33,6c.64.37.56,1-.17,1.43l-10,5.76a2.76,2.76,0,0,1-2.47.1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    className: "cls-19",
    d: "M44.21,101.17l-8.66-5c-.53-.31-.46-.84.15-1.2l8.36-4.82a2.29,2.29,0,0,1,2.07-.09l8.66,5c.53.31.47.84-.15,1.2l-8.36,4.82a2.29,2.29,0,0,1-2.07.09",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    className: "cls-21",
    d: "M53.28,100.12a1,1,0,0,1-.42.72c-.23.14-.42,0-.42-.24a.93.93,0,0,1,.42-.72c.23-.13.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    className: "cls-21",
    d: "M54.62,99.34a.93.93,0,0,1-.42.73c-.23.13-.42,0-.42-.24a.93.93,0,0,1,.42-.73c.23-.13.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    className: "cls-21",
    d: "M56,98.57a.9.9,0,0,1-.42.72c-.23.14-.41,0-.41-.24a.92.92,0,0,1,.41-.72c.23-.13.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    className: "cls-20",
    d: "M57.08,93.48h0V89.92h-8l-2.76-1.59a2.76,2.76,0,0,0-2.47.1l-2.58,1.49h-8v3.67a.69.69,0,0,0,.42.66l10.33,6a2.78,2.78,0,0,0,2.48-.1l10-5.76a1,1,0,0,0,.61-.86",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    className: "cls-20",
    d: "M45.17,88.07a3,3,0,0,0-1.33.35l-2.57,1.49h-8v3.67a.69.69,0,0,0,.42.66l10.33,6a2.19,2.19,0,0,0,1.15.24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    className: "cls-19",
    d: "M34.17,89.9h-.9v3.67a.69.69,0,0,0,.42.66l.48.28Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    className: "cls-19",
    d: "M44.18,100.28a2.81,2.81,0,0,0,2,0V96.09h-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    className: "cls-21",
    d: "M44,96.55l-10.33-6c-.63-.37-.55-1,.18-1.43l10-5.76a2.76,2.76,0,0,1,2.47-.1l10.33,6c.64.36.56,1-.17,1.43l-10,5.76a2.76,2.76,0,0,1-2.47.1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    className: "cls-19",
    d: "M44.21,95.47l-8.66-5c-.53-.3-.46-.84.15-1.19l8.36-4.83a2.29,2.29,0,0,1,2.07-.09l8.66,5c.53.31.47.84-.15,1.2l-8.36,4.83a2.32,2.32,0,0,1-2.07.08",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    className: "cls-21",
    d: "M53.28,94.42a1,1,0,0,1-.42.73c-.23.13-.42,0-.42-.25a.93.93,0,0,1,.42-.72c.23-.13.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    className: "cls-21",
    d: "M54.62,93.65a.93.93,0,0,1-.42.72c-.23.13-.42,0-.42-.24a.93.93,0,0,1,.42-.72c.23-.14.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    className: "cls-21",
    d: "M56,92.87a.9.9,0,0,1-.42.73c-.23.13-.41,0-.41-.25a.92.92,0,0,1,.41-.72c.23-.13.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    className: "cls-20",
    d: "M57.08,87.79h0V84.22h-8l-2.76-1.6a2.78,2.78,0,0,0-2.48.1l-2.57,1.49h-8v3.66a.74.74,0,0,0,.43.67L44,94.5a2.78,2.78,0,0,0,2.48-.1l10-5.76a1,1,0,0,0,.61-.86",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    className: "cls-20",
    d: "M45.17,82.38a2.83,2.83,0,0,0-1.33.34l-2.57,1.49h-8v3.66a.71.71,0,0,0,.42.67L44,94.5a2.3,2.3,0,0,0,1.15.25Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    className: "cls-19",
    d: "M34.17,84.21h-.9v3.66a.71.71,0,0,0,.42.67l.48.28Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    className: "cls-19",
    d: "M44.18,94.58a2.87,2.87,0,0,0,2,0V90.39h-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    className: "cls-21",
    d: "M44,90.85l-10.33-6c-.63-.37-.55-1,.18-1.43l10-5.76a2.72,2.72,0,0,1,2.47-.11l10.33,6c.64.36.56,1-.17,1.43l-10,5.76a2.76,2.76,0,0,1-2.47.1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    className: "cls-19",
    d: "M44.21,89.78l-8.66-5c-.53-.31-.46-.85.15-1.2l8.36-4.83a2.29,2.29,0,0,1,2.07-.08l8.66,5c.53.3.47.84-.15,1.19l-8.36,4.83a2.29,2.29,0,0,1-2.07.09",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    className: "cls-21",
    d: "M53.28,88.73a1,1,0,0,1-.42.72c-.23.13-.42,0-.42-.24a.91.91,0,0,1,.42-.72c.23-.14.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    className: "cls-21",
    d: "M54.62,88a.93.93,0,0,1-.42.72c-.23.14-.42,0-.42-.24a.93.93,0,0,1,.42-.72c.23-.13.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    className: "cls-21",
    d: "M56,87.18a.9.9,0,0,1-.42.72c-.23.13-.41,0-.41-.24a.9.9,0,0,1,.41-.72c.23-.14.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    className: "cls-20",
    d: "M57.08,82.09h0V78.52h-8l-2.76-1.6a2.73,2.73,0,0,0-2.47.11l-2.58,1.48h-8v3.67a.71.71,0,0,0,.42.66l10.33,6a2.75,2.75,0,0,0,2.48-.11l10-5.76a1,1,0,0,0,.61-.85",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    className: "cls-20",
    d: "M45.17,76.68a2.73,2.73,0,0,0-1.33.35l-2.57,1.48h-8v3.67a.71.71,0,0,0,.42.66l10.33,6a2.29,2.29,0,0,0,1.15.24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    className: "cls-19",
    d: "M34.17,78.51h-.9v3.67a.71.71,0,0,0,.42.66l.48.28Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    className: "cls-19",
    d: "M44.18,88.88a2.81,2.81,0,0,0,2,0V84.7h-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    className: "cls-21",
    d: "M44,85.15l-10.33-6c-.63-.37-.55-1,.18-1.43l10-5.76a2.72,2.72,0,0,1,2.47-.1l10.33,6c.64.37.56,1-.17,1.43l-10,5.76a2.76,2.76,0,0,1-2.47.1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    className: "cls-19",
    d: "M44.21,84.08l-8.66-5c-.53-.31-.46-.84.15-1.2l8.36-4.82A2.29,2.29,0,0,1,46.13,73l8.66,5c.53.3.47.84-.15,1.2L46.28,84a2.29,2.29,0,0,1-2.07.09",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    className: "cls-22",
    x: 48.43,
    y: 84.43,
    width: 4.79,
    height: 0.17,
    transform: "translate(-35.42 36.69) rotate(-29.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    className: "cls-21",
    d: "M53.28,83a1,1,0,0,1-.42.72c-.23.14-.42,0-.42-.24a.93.93,0,0,1,.42-.72c.23-.13.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    className: "cls-21",
    d: "M54.62,82.25a.93.93,0,0,1-.42.73c-.23.13-.42,0-.42-.24A.93.93,0,0,1,54.2,82c.23-.13.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    className: "cls-21",
    d: "M56,81.48a.9.9,0,0,1-.42.72c-.23.13-.41,0-.41-.24a.92.92,0,0,1,.41-.72c.23-.14.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    className: "cls-20",
    d: "M57.08,76.35h0V72.79h-8l-2.76-1.59a2.78,2.78,0,0,0-2.48.1l-2.57,1.49h-8v3.67a.71.71,0,0,0,.43.66l10.33,6A2.78,2.78,0,0,0,46.5,83l10-5.76a1,1,0,0,0,.61-.86",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    className: "cls-20",
    d: "M45.17,70.94a3,3,0,0,0-1.33.35l-2.57,1.49h-8v3.67a.69.69,0,0,0,.42.66l10.33,6a2.19,2.19,0,0,0,1.15.24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    className: "cls-19",
    d: "M34.17,72.77h-.9v3.67a.69.69,0,0,0,.42.66l.48.28Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    className: "cls-19",
    d: "M44.18,83.15a2.81,2.81,0,0,0,2,0V79h-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    className: "cls-21",
    d: "M44,79.42l-10.33-6c-.63-.37-.55-1,.18-1.43l10-5.76a2.75,2.75,0,0,1,2.47-.1l10.33,6c.64.37.56,1-.17,1.43l-10,5.76a2.73,2.73,0,0,1-2.47.11",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    className: "cls-22",
    d: "M56.47,72.85l-10,5.76a2.74,2.74,0,0,1-2.48.1l-10.33-6a.92.92,0,0,1-.31-.28.65.65,0,0,0,.19.92.34.34,0,0,0,.12.06l10.33,6a2.78,2.78,0,0,0,2.48-.1l10-5.76c.57-.33.75-.79.5-1.15a1.32,1.32,0,0,1-.5.44",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    className: "cls-21",
    d: "M53.28,77.29a1,1,0,0,1-.42.73c-.23.13-.42,0-.42-.24a.93.93,0,0,1,.42-.73c.23-.13.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    className: "cls-21",
    d: "M49.16,79.55a.92.92,0,0,1-.41.73c-.24.13-.42,0-.42-.24a.9.9,0,0,1,.42-.73c.23-.13.41,0,.41.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    className: "cls-22",
    d: "M49.16,85.46a.92.92,0,0,1-.41.73c-.24.13-.42,0-.42-.24a.9.9,0,0,1,.42-.73c.23-.13.41,0,.41.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    className: "cls-21",
    d: "M54.62,76.52a.93.93,0,0,1-.42.72c-.23.13-.42,0-.42-.24a.93.93,0,0,1,.42-.72c.23-.14.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    className: "cls-21",
    d: "M56,75.74a.9.9,0,0,1-.42.73c-.23.13-.41,0-.41-.25a.92.92,0,0,1,.41-.72c.23-.13.42,0,.42.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    className: "cls-19",
    d: "M44.63,75.72,39.8,72.93c-.3-.17-.26-.47.08-.67l4.67-2.7a1.28,1.28,0,0,1,1.16,0l4.83,2.79c.3.17.26.47-.08.66l-4.67,2.7a1.28,1.28,0,0,1-1.16,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    className: "cls-21",
    d: "M45.1,73.38,44.43,73s0-.06,0-.09l.65-.37a.18.18,0,0,1,.16,0l.66.39c.05,0,0,.06,0,.09l-.64.37a.18.18,0,0,1-.16,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    className: "cls-20",
    d: "M39.8,72.93h0l.07,0,4.67-2.7a1.32,1.32,0,0,1,1.16,0l4.82,2.79c.27-.2.29-.47,0-.62l-4.83-2.79a1.28,1.28,0,0,0-1.16,0l-4.67,2.7c-.34.2-.38.5-.08.67",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    className: "cls-21",
    d: "M43.62,80.26c0,.28-.19.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    className: "cls-19",
    d: "M42.26,79.48c0,.28-.2.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    className: "cls-21",
    d: "M43.62,81.91c0,.28-.19.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.4.44-.25a.94.94,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    className: "cls-21",
    d: "M42.26,81.13a.27.27,0,0,1-.44.25,1,1,0,0,1-.44-.76c0-.28.2-.4.44-.26a1,1,0,0,1,.44.77",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    className: "cls-21",
    d: "M43.62,85.92c0,.28-.19.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    className: "cls-21",
    d: "M42.26,85.14c0,.28-.2.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    className: "cls-19",
    d: "M43.62,87.57c0,.28-.19.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.4.44-.26a1,1,0,0,1,.44.77",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    className: "cls-21",
    d: "M42.26,86.78c0,.28-.2.4-.44.26a1,1,0,0,1-.44-.76c0-.28.2-.4.44-.26a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    className: "cls-21",
    d: "M43.62,91.59c0,.28-.19.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.4.44-.26a1,1,0,0,1,.44.77",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    className: "cls-19",
    d: "M42.26,90.8c0,.28-.2.4-.44.26a1,1,0,0,1-.44-.76c0-.28.2-.4.44-.26a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    className: "cls-21",
    d: "M43.62,93.23c0,.28-.19.4-.44.26a1,1,0,0,1-.44-.77.27.27,0,0,1,.44-.25,1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    className: "cls-19",
    d: "M42.26,92.45c0,.28-.2.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    className: "cls-19",
    d: "M43.62,97.31c0,.28-.19.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    className: "cls-21",
    d: "M42.26,96.53a.27.27,0,0,1-.44.25,1,1,0,0,1-.44-.76c0-.28.2-.4.44-.26a1,1,0,0,1,.44.77",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    className: "cls-21",
    d: "M43.62,99c0,.28-.19.4-.44.26a1,1,0,0,1-.44-.76c0-.28.2-.4.44-.26a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    className: "cls-19",
    d: "M42.26,98.17c0,.28-.2.4-.44.26a1,1,0,0,1-.44-.77c0-.28.2-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    className: "cls-19",
    d: "M43.62,103c0,.28-.19.4-.44.26a1,1,0,0,1-.44-.76c0-.28.2-.4.44-.26a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    className: "cls-21",
    d: "M42.26,102.19c0,.28-.2.4-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    className: "cls-19",
    d: "M43.62,104.62c0,.28-.19.4-.44.26a1,1,0,0,1-.44-.77c0-.28.2-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    className: "cls-21",
    d: "M42.26,103.84c0,.28-.2.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.4.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    className: "cls-21",
    d: "M43.62,108.71c0,.28-.19.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    className: "cls-19",
    d: "M42.26,107.93c0,.28-.2.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.39.44-.25a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    className: "cls-21",
    d: "M43.62,110.36c0,.28-.19.39-.44.25a1,1,0,0,1-.44-.76c0-.28.2-.4.44-.25a.94.94,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    className: "cls-21",
    d: "M42.26,109.57c0,.28-.2.4-.44.26a1,1,0,0,1-.44-.76c0-.28.2-.4.44-.26a1,1,0,0,1,.44.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    className: "cls-7",
    d: "M157.7,137.12a15.34,15.34,0,0,0-13.87,0c-3.83,2.21-3.83,5.79,0,8a15.34,15.34,0,0,0,13.87,0c3.82-2.21,3.82-5.79,0-8M154,143a7,7,0,0,1-6.37,0c-1.76-1-1.76-2.66,0-3.68a7,7,0,0,1,6.37,0c1.76,1,1.76,2.66,0,3.68",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    className: "cls-17",
    d: "M142.39,134.08l3.49.06a3.68,3.68,0,0,1,1.11-.93,8.43,8.43,0,0,1,7-.26l2.08-2,3.2,0-.49-.3a17.79,17.79,0,0,0-16.11,0,8.63,8.63,0,0,0-2,1.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    className: "cls-18",
    d: "M159.31,126V131l-3.2,0v-5.07Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    className: "cls-17",
    d: "M154,127.87V133l2.08-1.95v-5.08Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    className: "cls-17",
    d: "M145.88,129.06v5.08l4.61-3.75L154,133v-5.08l-3.27-1.59s-4.49,1.38-4.72,1.44-.16,1.33-.16,1.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    className: "cls-17",
    d: "M142.39,129v5.08l3.49.06v-5.08Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    className: "cls-18",
    d: "M140.71,127.22v5.08l1.68,1.78V129Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    className: "cls-3",
    d: "M142.39,129l3.49.06a3.68,3.68,0,0,1,1.11-.93,8.43,8.43,0,0,1,7-.26l2.08-2,3.2,0-.49-.31a17.79,17.79,0,0,0-16.11,0,8.63,8.63,0,0,0-2,1.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    className: "cls-16",
    d: "M155.08,128.49v4.67l3-.72s-.18-2.73-.24-2.81-2.79-1.14-2.79-1.14",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    className: "cls-16",
    d: "M152.79,133.16v5.08l.33.35,2.13-1.23s-.33-3.88-.37-4c-.69-.11-1.39-.19-2.09-.24",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    className: "cls-16",
    d: "M156.91,131.85l-1.83,1.72c1.53,1.21,1.35,2.91-.54,4a6.88,6.88,0,0,1-1.75.67l1.89,2L153,141.83a15.14,15.14,0,0,0,5.81-1.8c3.82-2.2,4.35-5.59,1.6-8.13Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    className: "cls-16",
    d: "M153,136.75v5.08l4.15-1.6,5-4.76,0-5.39-5.28,4.18Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    className: "cls-4",
    d: "M156.91,126.77l-1.83,1.72c1.53,1.21,1.35,2.91-.54,4a6.53,6.53,0,0,1-1.75.67l1.89,2L153,136.75a15.3,15.3,0,0,0,5.81-1.79c3.82-2.21,4.35-5.6,1.6-8.13Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    className: "cls-10",
    d: "M153,140.23l-1.66-1.78a8,8,0,0,1-4.34-.88c-1.23-.71-1.73-1.67-1.52-2.59l-4-.07L140,133.29c-1.34,2.29-.43,4.92,2.73,6.75a16.71,16.71,0,0,0,8.45,1.92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    className: "cls-10",
    d: "M151.16,136.88V142l-11.78-6.53v-5.08l1.72.7Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    className: "cls-44",
    d: "M153,135.15v5.08L151.16,142v-5.07Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    className: "cls-11",
    d: "M153,135.15l-1.66-1.78a7.87,7.87,0,0,1-4.34-.88c-1.23-.71-1.73-1.67-1.52-2.59l-4-.06L140,128.21c-1.34,2.29-.43,4.92,2.73,6.75a16.71,16.71,0,0,0,8.45,1.92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    className: "cls-16",
    d: "M57.06,59.24l-9-5.19a.45.45,0,0,0-.46,0h0l-.87.51.61.22v6.55a1.75,1.75,0,0,0,.72,1.38l8.6,5v.77l.88-.51h0a.65.65,0,0,0,.24-.57V60.62a1.75,1.75,0,0,0-.72-1.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    className: "cls-4",
    d: "M56.17,68.36l-9-5.19a1.73,1.73,0,0,1-.73-1.38V55.11c0-.54.33-.78.73-.55l9,5.19a1.72,1.72,0,0,1,.72,1.38v6.69c0,.53-.32.77-.72.54",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    className: "cls-22",
    d: "M50.2,60.87c0,.39-.27.54-.6.35a1.38,1.38,0,0,1-.61-1c0-.39.27-.55.61-.35a1.34,1.34,0,0,1,.6,1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    className: "cls-22",
    d: "M52,61.93c0,.39-.27.54-.61.35a1.34,1.34,0,0,1-.6-1.05c0-.39.27-.54.6-.35a1.32,1.32,0,0,1,.61,1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    className: "cls-22",
    d: "M53.88,63c0,.39-.28.54-.61.35a1.34,1.34,0,0,1-.6-1.05c0-.39.27-.54.6-.35A1.35,1.35,0,0,1,53.88,63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    className: "cls-19",
    d: "M51.94,50.83l-9-5.19a.47.47,0,0,0-.47,0h0l-.87.5.61.23v6.54A1.73,1.73,0,0,0,43,54.25l8.59,5V60l.89-.5h0a.66.66,0,0,0,.25-.58V52.21a1.74,1.74,0,0,0-.73-1.38",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    className: "cls-21",
    d: "M51.05,60l-9-5.19a1.74,1.74,0,0,1-.72-1.39V46.7c0-.53.32-.78.72-.55l9,5.19a1.75,1.75,0,0,1,.73,1.39v6.68c0,.53-.33.78-.73.55",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    className: "cls-22",
    d: "M45.09,52.46c0,.39-.28.55-.61.35a1.31,1.31,0,0,1-.6-1.05c0-.38.27-.54.6-.35a1.38,1.38,0,0,1,.61,1.05",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    className: "cls-22",
    d: "M46.92,53.52c0,.39-.27.55-.6.35a1.35,1.35,0,0,1-.61-1,.37.37,0,0,1,.61-.35,1.34,1.34,0,0,1,.6,1.05",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    className: "cls-22",
    d: "M48.76,54.58c0,.39-.27.55-.6.35a1.32,1.32,0,0,1-.61-1c0-.38.27-.54.61-.35a1.37,1.37,0,0,1,.6,1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    className: "cls-18",
    d: "M29.23,122.05l-9-5.19a.47.47,0,0,0-.47,0h0l-.87.5.61.23v6.55a1.75,1.75,0,0,0,.72,1.38l8.6,5v.77l.88-.51h0a.65.65,0,0,0,.24-.58v-6.68a1.77,1.77,0,0,0-.72-1.39",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    className: "cls-17",
    d: "M29.71,130.7h0a.68.68,0,0,0,.24-.58v-6.68a1.88,1.88,0,0,0-.2-.78l-7.2,4.15,6.28,3.63v.77Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    className: "cls-3",
    d: "M28.34,131.18l-9-5.19a1.73,1.73,0,0,1-.73-1.38v-6.69c0-.53.33-.78.73-.54l9,5.19a1.75,1.75,0,0,1,.72,1.38v6.69c0,.53-.32.77-.72.54",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    className: "cls-19",
    x: 130.75,
    y: 121.69,
    width: 2.27,
    height: 4.89,
    transform: "matrix(0.63, -0.77, 0.77, 0.63, -47.67, 147.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    className: "cls-19",
    d: "M133.63,126.6a1.76,1.76,0,0,0,1-1.25c.08-.5-.24-.76-.71-.58a1.77,1.77,0,0,0-1,1.24c-.08.5.24.77.72.59",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    className: "cls-19",
    x: 126.88,
    y: 119.06,
    width: 3.67,
    height: 4.99,
    transform: "translate(-46.83 144.49) rotate(-50.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    className: "cls-20",
    d: "M131.33,122.22l1.28,1a3,3,0,0,1-1.43,1.76l-1.28-1a3,3,0,0,1,1.43-1.76",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    className: "cls-19",
    d: "M130.41,124.61a2.85,2.85,0,0,0,1.64-2c.13-.82-.38-1.24-1.16-.95a2.85,2.85,0,0,0-1.64,2c-.13.82.39,1.25,1.16,1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    className: "cls-19",
    d: "M126.54,121.45a2.83,2.83,0,0,0,1.64-2c.13-.81-.39-1.24-1.16-.94a2.83,2.83,0,0,0-1.64,2c-.13.81.39,1.24,1.16.94",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    className: "cls-21",
    d: "M126.65,120.81a1.63,1.63,0,0,0,.93-1.14c.07-.46-.22-.7-.66-.53a1.63,1.63,0,0,0-.93,1.14c-.07.46.22.7.66.53",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    className: "cls-21",
    d: "M133.64,125.16c.19.15.37.08.41-.16a.82.82,0,0,0-.27-.7c-.19-.15-.37-.08-.41.15a.89.89,0,0,0,.27.71",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    className: "cls-19",
    d: "M98.12,159.7a3.44,3.44,0,0,1-1.79-.51l-2.43-1.44a.27.27,0,1,1,.28-.47l2.43,1.44A2.93,2.93,0,0,0,101,156l-.05-.74c-.86-12-2.44-34.33,7-36.74a72.49,72.49,0,0,0,7.08-2.2c4.83-1.73,5.16-1.64,11.82,3.39a.28.28,0,0,1,.06.39.28.28,0,0,1-.39,0h0c-6.61-5-6.7-5-11.3-3.32a74.41,74.41,0,0,1-7.13,2.22c-9,2.3-7.41,24.33-6.56,36.17l0,.73a3.49,3.49,0,0,1-3.46,3.73",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    className: "cls-7",
    d: "M122.88,162.64a13.9,13.9,0,0,1-12.59,0c-3.48-2-3.48-5.26,0-7.27a13.9,13.9,0,0,1,12.59,0c3.48,2,3.48,5.26,0,7.27",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    className: "cls-7",
    d: "M120.84,156.8a1.37,1.37,0,0,1,.77,1.38,2.54,2.54,0,0,1-.11.67,1.13,1.13,0,0,1-1.52.46c-.84-.33-2.69-2.07-2.76-3.21-.13-2.12,2.29.14,3.61.7",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    className: "cls-7",
    d: "M115.93,160.31a6.31,6.31,0,0,1,.1,1.44,1.55,1.55,0,0,1-1.53.6c-.86-.1-3.33-.95-3.88-2.58-.85-2.52,4.77.19,4.77.19Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    className: "cls-3",
    d: "M113.52,140.78l-.2,19.07a1.34,1.34,0,0,0,1,1.32l.23,0a1.19,1.19,0,0,0,1.14-.47A1.41,1.41,0,0,0,116,160l.25-8.14,1.21-7.27,1.68,12.87a1.14,1.14,0,0,0,.46.85,1.32,1.32,0,0,0,.77.21,1.45,1.45,0,0,0,1-.5,1,1,0,0,0,.24-.69l-.66-7.75-.25-9.89Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    className: "cls-45",
    d: "M116,123.72l.31,1.74a.8.8,0,0,1-.66.75c-.66.17-.86-.26-.86-.26l-.3-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    className: "cls-45",
    d: "M112.45,123.77a2.53,2.53,0,1,0-.23-3.78,2.68,2.68,0,0,0,.23,3.78",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    className: "cls-44",
    d: "M115.9,125.49s2.81-1.8,3.83.06c1.67,3,1.57,12.81,1,14.07a5.89,5.89,0,0,1-2.55,2.52,5.13,5.13,0,0,1-2.48.71c-.86,0-2.51-.76-2.45-1.89a87,87,0,0,0-.61-13.81,10.76,10.76,0,0,1,3.23-1.66",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    className: "cls-51",
    d: "M117.44,144.55l1.68,12.87a1.14,1.14,0,0,0,.46.85l.15.08c-.35-.26-1.37-11.07-1.56-12.27a2.15,2.15,0,0,0-.73-1.53",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    className: "cls-45",
    d: "M107.07,126.06l-1.5-4.91.8-.33,1.76,3.85Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    className: "cls-45",
    d: "M122.2,122.19l-1.12-5.12h-.9l.34,4.24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    className: "cls-44",
    d: "M112.68,127.15s-2.7.54-4.41-2.6a.42.42,0,0,0-.57-.19.38.38,0,0,0-.14.11,2.17,2.17,0,0,0-.45,1.75c.83,3.07,5.37,3.75,6.18,5.53s-.61-4.6-.61-4.6",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    className: "cls-44",
    d: "M117.66,124.85s2.13.16,2.44-1.68a14.35,14.35,0,0,0,.21-1.85.38.38,0,0,1,.38-.37h0c.51.06,1.3.21,1.41.55.16.52.47,3-1.64,6.88-1.39,2.52-2.84-3.54-2.84-3.54",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    className: "cls-45",
    d: "M121.08,117.08l0-.58a1.27,1.27,0,0,0-.17-.58l-.59-1-.16-.19a.45.45,0,0,0-.59-.1l-.14.08a.59.59,0,0,0-.26.52l.31.83-.39-.08a.14.14,0,0,0-.15.13.14.14,0,0,0,.08.13l.63.26.57.81Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    className: "cls-45",
    d: "M105.55,121.17l-.18-.56a1.22,1.22,0,0,1,0-.6l.23-1.12.08-.23a.44.44,0,0,1,.52-.3l.15,0a.56.56,0,0,1,.42.39v.89l.33-.2a.13.13,0,0,1,.19.06.18.18,0,0,1,0,.16l-.51.45-.3,1.08Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    className: "cls-9",
    d: "M113.94,130.87c.25,1.12-.44,9.82,1.81,12-.87,0-2.52-.76-2.46-1.89a69.19,69.19,0,0,0-.21-9.55c-.88-1.14-3.3-1.86-4.82-3.33.11,0,5.44,1.68,5.68,2.79",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    className: "cls-22",
    d: "M116.9,125l-.38-.4a3.13,3.13,0,0,1-1.14.76,5.66,5.66,0,0,1-.91.19l-.25.68s2-.15,2.68-1.23",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    className: "cls-7",
    d: "M114.07,123a.32.32,0,0,1-.3,0c-.16-.09-.43-.74-.77-.69-.53.07-1.3,1.19-2.25-.37-.5-.81-.21-1.24-.45-1.7,0,0,.08.25,2.17-1a3.1,3.1,0,0,1,4.32,1.16,2.7,2.7,0,0,1-.5,3.6,3.33,3.33,0,0,1-1.72-.25c0-.12.36-.32.14-.61a.45.45,0,0,0-.63-.13h0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    className: "cls-17",
    d: "M18.9,117.32l4.94,7,5-1.11-5.12,1.66Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    className: "cls-17",
    d: "M24.42,124.49l.42-.11,4,6.83Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    className: "cls-17",
    d: "M23.37,124.08l-4.44,1.5,4.21-1.89Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    className: "cls-16",
    d: "M21.15,117.93a5.38,5.38,0,0,0-2.42-4.21,1.73,1.73,0,0,0-1.69-.18h0l-.84.49.4,0a2.23,2.23,0,0,0-.26,1.1,5.36,5.36,0,0,0,2.43,4.21,2.31,2.31,0,0,0,1,.32l-.18.37.87-.51.06,0,0,0h0a1.76,1.76,0,0,0,.65-1.54",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    className: "cls-4",
    d: "M20.27,118.43c0,1.55-1.08,2.18-2.42,1.4a5.33,5.33,0,0,1-2.43-4.2c0-1.55,1.09-2.17,2.43-1.4a5.36,5.36,0,0,1,2.42,4.2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    className: "cls-22",
    d: "M17.81,118.57a1.59,1.59,0,0,1-.33-.25,1.06,1.06,0,0,1-.21-.31,1.4,1.4,0,0,1-.1-.35,2.69,2.69,0,0,1,0-.4l.44.25c0,.09,0,.16,0,.22l0,.18a.48.48,0,0,0,.08.16.47.47,0,0,0,.13.11.12.12,0,0,0,.09,0H18a.09.09,0,0,0,0-.06l0-.08s0-.08,0-.12v-.14a.85.85,0,0,0,0-.16v-.2a1,1,0,0,0,0-.17.42.42,0,0,0,0-.15.75.75,0,0,0-.07-.12.31.31,0,0,0-.11-.09.16.16,0,0,0-.16,0,.19.19,0,0,0-.09.14l-.39-.23,0-1.69,1.2.7v.48l-.81-.47,0,.7a.22.22,0,0,1,.14,0,.49.49,0,0,1,.21.08.79.79,0,0,1,.27.21,1,1,0,0,1,.19.29,1.61,1.61,0,0,1,.1.36,2.71,2.71,0,0,1,0,.41c0,.12,0,.23,0,.35a1.18,1.18,0,0,1-.06.27.46.46,0,0,1-.13.18.34.34,0,0,1-.2,0,1,1,0,0,1-.29-.11",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    className: "cls-4",
    d: "M71.62,50.75a4.31,4.31,0,1,1,4.31-4.3h0a4.31,4.31,0,0,1-4.31,4.3m0-7.67A3.37,3.37,0,1,0,75,46.45h0a3.37,3.37,0,0,0-3.37-3.37",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    className: "cls-3",
    d: "M57.36,156a3.06,3.06,0,1,1,3-3,3,3,0,0,1-3,3m0-5.17A2.12,2.12,0,1,0,59.47,153h0a2.11,2.11,0,0,0-2.11-2.12",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    className: "cls-4",
    d: "M84.61,28.57l-2.07-4.21,4.22-2.07,2.07,4.21Zm-.81-3.78L85,27.32l2.53-1.25-1.24-2.53Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    className: "cls-10",
    x: 155.54,
    y: 25.6,
    width: 4.46,
    height: 0.94,
    transform: "translate(27.77 119.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    className: "cls-10",
    x: 157.3,
    y: 23.84,
    width: 0.94,
    height: 4.46,
    transform: "translate(27.77 119.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    className: "cls-3",
    d: "M70.9,49.29a3.12,3.12,0,1,1-3.11-3.12h0a3.11,3.11,0,0,1,3.11,3.11h0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    className: "cls-3",
    d: "M28.32,95A2.28,2.28,0,1,1,26,92.67h0A2.28,2.28,0,0,1,28.32,95",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    className: "cls-4",
    d: "M54.09,157.32a1.84,1.84,0,1,1-1.84-1.83h0a1.83,1.83,0,0,1,1.84,1.83",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    className: "cls-10",
    d: "M192.86,87.85a1,1,0,1,1-.61-1.34,1,1,0,0,1,.61,1.34",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    className: "cls-3",
    x: 185.15,
    y: 79.23,
    width: 4.34,
    height: 4.34,
    transform: "translate(45.07 227.95) rotate(-69.34)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudComputing1);
export default __webpack_public_path__ + "static/media/cloud-computing-1.d05c22b0088b3e66484ac5d3bf9e963d.svg";
export { ForwardRef as ReactComponent };